import React, { useEffect, FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import { DateTime } from "luxon";
import { CircularProgress, Select, MenuItem, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { postRequest } from "../../../apis/axiosAction";
import TenpoCheckDialog from "../TenpoCheckDialog";
import { selectUser } from "../../../features/userSlice";
import { getPastWeekMondays } from "../../../apis/util";
import { useDispatch, useSelector } from "react-redux";
import TenpoCheckManagerAnalysisTable from "./TenpoCheckManagerAnalysisTable";
import TenpoCheckManagerAnalysisTemplateTable from "./TenpoCheckManagerAnalysisTemplateTable";
import DatePicker from "../../common/DatePicker";
import { zonedTimeToUtc } from "date-fns-tz";
import { userLogging } from "../../../apis/userLog";
import { sendTenpoCheckDoAllStoreAnalysisAccessLog, sendTenpoCheckDoTemplateAnalysisAccessLog, sendTenpoCheckStoreAnalysisAccessLog } from "../../../apis/accessLogService";
import { getFirestoreDocData } from "../../../apis/firestoreAction";
import TenpoCheckStoreScoreDataButton from "./TenpoCheckStoreScoreDataButton";
import {
  isDownloadPointData,
  isDmCheck,
  isZmCheck,
  hasManagerAnalysisFullReferencePrivileges,
} from "../../../apis/privilege";
import {
  getTemplateData,
  getZocodeInfo,
  ZENKOKU_CODE,
} from "../Register/TenpoCheckTableDataOperation";
import {
  updateTenpoCheckManagerTab,
  updateTenpoCheckManagerMap,
} from "../../organisms/search/TenpoCheckSearchSlice";
import { ANALYSIS_TYPES } from "../constants";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "70vh",
    width: "90vw",
    margin: "auto",
    // iPad縦
    "@media (min-width: 830px)": {
      height: "65vh",
    },
    // iPad横
    "@media (min-width: 1100px)": {
      height: "70vh",
    },
    // GWPC
    "@media (min-width: 1300px)": {
      height: "70vh",
    },
  },
  graphTable: {
    maxWidth: "80vw",
    backgroundColor: "#ffffff",
    border: "none",
    marginTop: "10px",
    marginBottom: "5px",
  },
  overLayer: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    backgroundColor: "#CCC",
    opacity: "0.5",
    zIndex: 100000,
  },
  circularProgress: {
    position: "absolute",
    top: "35%",
    left: "45%",
    opacity: "0.8",
    color: "#ccc",
    zIndex: 99999,
  },
}));

// グラフの色リスト
const fillCodeList = [
  "#8884d8",
  "#82ca9d",
  "skyblue",
  "coral",
  "peru",
  "plum",
  "gold",
  "pink",
  "blue",
  "red",
];
const tableHeaderList2 = [
  "店外",
  "店内・バックルーム・事務所",
  "酒類不当廉売・酒類法定表示物、免許品販売時の年齢確認",
  "設備・什器",
  "フレンドリー確認事項",
  "店舗留置き商品",
  "感染症対策",
  "商品・売場・地区政策等",
];

const initSmallTitle: any = { id: 1, name: "全体" };
const initSmallTitle2: any = { id: 101, name: "コメント数" };
const initSmallTitle3: any = { id: 102, name: "写真数" };

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// 実行結果
const AnalysisResult: FC<{
  zoCode: string;
  doCode: string;
  baseData: DateTime | null;
  update: boolean;
  analysis: number;
  initTabValue: number;
  initTableMap: any;
}> = ({
  zoCode,
  doCode,
  baseData,
  update,
  analysis,
  initTabValue,
  initTableMap,
}) => {
  const classes = useStyles();
  const user = useSelector(selectUser);
  const [tabValue, setTabValue] = React.useState(
    initTabValue ? initTabValue : 0
  );
  const dispatch = useDispatch();
  const [indexTabValue, setIndexTabValue] = React.useState(
    initTabValue ? initTabValue : 0
  );

  const [targetData, setTargetData] = React.useState<any[]>();
  const [targetGraphData, setTargetGraphData] = React.useState<any[]>();
  const [targetData0, setTargetData0] = React.useState<any[]>([]);
  const [targetData1, setTargetData1] = React.useState<any[]>([]);
  const [targetData2, setTargetData2] = React.useState<any[]>([]);
  const [targetData3, setTargetData3] = React.useState<any[]>([]);
  const [targetData4, setTargetData4] = React.useState<any[]>([]);
  const [targetData5, setTargetData5] = React.useState<any[]>([]);
  const [targetData6, setTargetData6] = React.useState<any[]>([]);
  const [targetData7, setTargetData7] = React.useState<any[]>([]);
  const [targetData8, setTargetData8] = React.useState<any[]>([]);
  const [targetDataCommentCount, setTargetDataCommentCount] = React.useState<
    any[]
  >([]);
  const [targetDataFileCount, setTargetDataFileCount] = React.useState<any[]>(
    []
  );

  const [targetSmallData, setTargetSmallData] = React.useState<any[]>([]);
  const [targetSmallAverageData, setTargetSmallAverageData] =
    React.useState<any>({});

  const [targetAverageData, setTargetAverageData] = React.useState<any>({});
  const [targetAverageData0, setTargetAverageData0] = React.useState<any>({});
  const [targetAverageData1, setTargetAverageData1] = React.useState<any>({});
  const [targetAverageData2, setTargetAverageData2] = React.useState<any>({});
  const [targetAverageData3, setTargetAverageData3] = React.useState<any>({});
  const [targetAverageData4, setTargetAverageData4] = React.useState<any>({});
  const [targetAverageData5, setTargetAverageData5] = React.useState<any>({});
  const [targetAverageData6, setTargetAverageData6] = React.useState<any>({});
  const [targetAverageData7, setTargetAverageData7] = React.useState<any>({});
  const [targetAverageData8, setTargetAverageData8] = React.useState<any>({});
  const [targetAverageDataCommentCount, setTargetAverageDataCommentCount] =
    React.useState<any>({});
  const [targetAverageDataFileCount, setTargetAverageDataFileCount] =
    React.useState<any>({});

  const [graphUserList, setGraphUserList] = React.useState<any[]>([]);

  const [workZoCode, setWorkZoCode] = React.useState(zoCode);
  const [workDoCode, setWorkDoCode] = React.useState(doCode);
  const [templateZoCode, setTemplateZoCode] = React.useState(zoCode);
  const [ofcId, setOfcId] = React.useState("");
  const [tenpoCode, setTenpoCode] = React.useState("");
  const [executeFlg, setExecuteFlg] = React.useState("");
  const [initFlg, setInigFlg] = React.useState(true);
  const [updateFlg, setUpdateFlg] = React.useState(true);
  const [workBaseData, setWorkBaseData] = React.useState(baseData);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [zoTabDisableFlg, setZoTabDisableFlg] = React.useState(true);
  const [doTabDisableFlg, setDoTabDisableFlg] = React.useState(true);
  const [ofcTabDisableFlg, setOfcTabDisableFlg] = React.useState(true);
  const [kobetuTabDisableFlg, setKobetuTabDisableFlg] = React.useState(true);
  const [templateTabDisableFlg, setTemplateTabDisableFlg] = React.useState(true);

  const [tableHeaderList, setTableHeaderList] = React.useState<any[]>([]);
  const [headerName, setHeaderName] = React.useState("");
  const [tableSubmissionHeaderList, setTableSubmissionHeaderList] =
    React.useState<string[]>([]);

  const [tableList, setTableList] = React.useState<any[]>([
    { id: 1, name: "総合" },
  ]);
  const [smallTitleList1, setSmallTitleList1] = React.useState<any[]>([]);
  const [smallTitleList2, setSmallTitleList2] = React.useState<any[]>([]);
  const [smallTitleList3, setSmallTitleList3] = React.useState<any[]>([]);
  const [smallTitleList4, setSmallTitleList4] = React.useState<any[]>([]);
  const [smallTitleList5, setSmallTitleList5] = React.useState<any[]>([]);
  const [smallTitleList6, setSmallTitleList6] = React.useState<any[]>([]);
  const [smallTitleList7, setSmallTitleList7] = React.useState<any[]>([]);
  const [smallTitleList, setSmallTitleList] = React.useState<any[]>([
    initSmallTitle,
    initSmallTitle2,
    initSmallTitle3,
  ]);
  const [selectedSmallFlg, setSelectedSmallFlg] = React.useState(false);
  const [templateItemList, setTemplateItemList] = React.useState<any[]>([]);
  const [templateSmallItemList, setTemplateSmallItemList] = React.useState<
    any[]
  >([]);
  const [templatesMap, setTemplatesMap] = React.useState<any>({});

  const [selectedTable, setSelectedTable] = React.useState("1");
  const [selectedSmallTitle, setSelectedSmallTitle] = React.useState("1");
  const [selectedTemplateSmallTitle, setSelectedTemplateSmallTitle] =
    React.useState("0");
  const [selectedTemplateBigItemId, setSelectedTemplateBigItemId] =
    React.useState("");

  const [selectedBaseDate, setSelectedBaseDate] =
    React.useState<DateTime | null>(null);
  const [selectedSmallBaseDate, setSelectedSmallBaseDate] =
    React.useState<DateTime | null>(null);
  const [baseWeek, setBaseWeek] = React.useState<string>("");
  const [smallBaseWeek, setSmallBaseWeek] = React.useState<string>("");

  const [allDoFlg, setAllDoFlg] = React.useState(false);

  const [tmpInitTableMap, setTmpInitTableMap] = React.useState<any>({});
  const [clickFlg, setClickFlg] = React.useState(false);

  const [selectedTemplateItemName, setSelectedTemplateItemName] =
    React.useState<string>("");
  const [selectedTemplateItemUuid, setSelectedTemplateItemUuid] =
    React.useState<string>("");
  
  // テンプレートタブ用の週選択状態
  const [selectedWeek, setSelectedWeek] = React.useState<string>("");
  const [weekOptions, setWeekOptions] = React.useState<Array<{value: string, label: string}>>([]);

  const cloneList = (list: any) => {
    let newList: any[] = [];
    if (list) {
      for (const item of list) {
        newList.push(item);
      }
    }
    return newList;
  };
  const cloneListMap = (list: any) => {
    let newList: any[] = [];
    if (list) {
      for (const map of list) {
        newList.push(cloneMap(map));
      }
    }
    return newList;
  };
  const cloneMap = (map: any) => {
    let newMap: any = {};
    Object.keys(map).forEach(function (key) {
      newMap[key] = map[key];
    });
    return newMap;
  };
  // データ取得用useEffect
  useEffect(() => {
    changeTitles(tabValue);
    getSmallTitles();

    if (initFlg) {
      getTemplateTitles();
      userLogging("店舗確認表", "管理者分析#初期表示", "");
      setInigFlg(false);

      if (initTabValue && initTableMap) {
        let initSelectedTable: string = initTableMap["selectedTable"];
        setSelectedTable(initSelectedTable);
        let initSelectedSmallTable: string = initTableMap["selectedSmallTable"];
        setSelectedSmallTitle(initSelectedSmallTable);
        setSelectedTemplateSmallTitle(
          initTableMap["selectedTemplateSmallTitle"]
        );

        let initTargetDataMap = cloneListMap(initTableMap["targetList0"]);
        let initTargetAverageData = cloneMap(
          initTableMap["targetAverageData0"]
        );

        switch (initSelectedTable) {
          case "1":
            if (initSelectedSmallTable) {
              if (initSelectedSmallTable === "101") {
                initTargetDataMap = cloneListMap(
                  initTableMap["targetListCommentCount"]
                );
                initTargetAverageData = cloneMap(
                  initTableMap["targetAverageDataCommentCount"]
                );
              }
              if (initSelectedSmallTable === "102") {
                initTargetDataMap = cloneListMap(
                  initTableMap["targetListFileCount"]
                );
                initTargetAverageData = cloneMap(
                  initTableMap["targetAverageDataFileCount"]
                );
              }
            } else {
              initTargetDataMap = cloneListMap(initTableMap["targetList0"]);
              initTargetAverageData = cloneMap(
                initTableMap["targetAverageData0"]
              );
            }
            break;
          case "2":
            initTargetDataMap = cloneListMap(initTableMap["targetList1"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData1"]
            );
            break;
          case "3":
            initTargetDataMap = cloneListMap(initTableMap["targetList2"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData2"]
            );
            break;
          case "4":
            initTargetDataMap = cloneListMap(initTableMap["targetList3"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData3"]
            );
            break;
          case "5":
            initTargetDataMap = cloneListMap(initTableMap["targetList4"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData4"]
            );
            break;
          case "6":
            initTargetDataMap = cloneListMap(initTableMap["targetList5"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData5"]
            );
            break;
          case "7":
            initTargetDataMap = cloneListMap(initTableMap["targetList6"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData6"]
            );
            break;
          case "8":
            initTargetDataMap = cloneListMap(initTableMap["targetList7"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData7"]
            );
            break;
          case "9":
            initTargetDataMap = cloneListMap(initTableMap["targetList8"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData8"]
            );
            break;
        }

        setSmallTitleList([initSmallTitle, initSmallTitle2, initSmallTitle3]);
        if (initTableMap["smallTitleList"]) {
          setSmallTitleList(cloneList(initTableMap["smallTitleList"]));
        }

        if (initTableMap["selectedSmallFlg"]) {
          setSelectedSmallFlg(initTableMap["selectedSmallFlg"]);
          setTargetSmallData(cloneListMap(initTableMap["targetSmallData"]));
          setTargetSmallAverageData(
            cloneMap(initTableMap["targetSmallAverageData"])
          );
          setTemplateSmallItemList(
            cloneListMap(initTableMap["templateSmallItemList"])
          );
          let selectedSmallDate = initTableMap["selectedSmallBaseDate"];
          if (selectedSmallDate) {
            let smallBaseDateTime = DateTime.fromFormat(
              selectedSmallDate,
              "yyyyMMdd"
            );
            setSelectedSmallBaseDate(smallBaseDateTime);
            setSmallBaseWeek(
              getFirstDayOfWeek(smallBaseDateTime.toFormat("yyyyMMdd"), 0)
            );
          }
        }

        setTargetData(initTargetDataMap);
        setTargetAverageData(initTargetAverageData);

        setTargetData0(cloneListMap(initTableMap["targetList0"]));
        setTargetData1(cloneListMap(initTableMap["targetList1"]));
        setTargetData2(cloneListMap(initTableMap["targetList2"]));
        setTargetData3(cloneListMap(initTableMap["targetList3"]));
        setTargetData4(cloneListMap(initTableMap["targetList4"]));
        setTargetData5(cloneListMap(initTableMap["targetList5"]));
        setTargetData6(cloneListMap(initTableMap["targetList6"]));
        setTargetData7(cloneListMap(initTableMap["targetList7"]));
        setTargetData8(cloneListMap(initTableMap["targetList8"]));
        setTargetDataCommentCount(
          cloneListMap(initTableMap["targetListCommentCount"])
        );
        setTargetDataFileCount(
          cloneListMap(initTableMap["targetListFileCount"])
        );

        setTargetAverageData0(cloneMap(initTableMap["targetAverageData0"]));
        setTargetAverageData1(cloneMap(initTableMap["targetAverageData1"]));
        setTargetAverageData2(cloneMap(initTableMap["targetAverageData2"]));
        setTargetAverageData3(cloneMap(initTableMap["targetAverageData3"]));
        setTargetAverageData4(cloneMap(initTableMap["targetAverageData4"]));
        setTargetAverageData5(cloneMap(initTableMap["targetAverageData5"]));
        setTargetAverageData6(cloneMap(initTableMap["targetAverageData6"]));
        setTargetAverageData7(cloneMap(initTableMap["targetAverageData7"]));
        setTargetAverageData8(cloneMap(initTableMap["targetAverageData8"]));
        setTargetAverageDataCommentCount(
          cloneMap(initTableMap["targetAverageDataCommentCount"])
        );
        setTargetAverageDataFileCount(
          cloneMap(initTableMap["targetAverageDataFileCount"])
        );

        setTableSubmissionHeaderList(initTableMap["tableSubmissionHeaderList"]);
        setTableHeaderList(initTableMap["tableHeaderList"]);
        setTableList(initTableMap["tableList"]);
        let initWorkZoCode = initTableMap["workZoCode"];
        let initWorkDoCode = initTableMap["workDoCode"];
        let initWorkOfcId = initTableMap["ofcId"];
        let initTemplateZoCode = initTableMap["templateZoCode"];
        setWorkZoCode(initWorkZoCode);
        setWorkDoCode(initWorkDoCode);
        setTemplateZoCode(initTemplateZoCode);
        setOfcId(initWorkOfcId);
        setTenpoCode(initTableMap["tenpoCode"]);
        setTemplateItemList(cloneListMap(initTableMap["templateItemList"]));
        setTemplatesMap(cloneMap(initTableMap["templatesMap"]));
        setTemplateSmallItemList(
          cloneListMap(initTableMap["templateSmallItemList"])
        );
        setAllDoFlg(initTableMap["allDoFlg"]);
        setIndexTabValue(initTableMap["indexTabValue"]);
        let selectedDate = initTableMap["selectedBaseDate"];
        if (selectedDate) {
          let baseDateTime = DateTime.fromFormat(selectedDate, "yyyyMMdd");
          setSelectedBaseDate(baseDateTime);
          setBaseWeek(getFirstDayOfWeek(baseDateTime.toFormat("yyyyMMdd"), 0));
        }

        updateDisableTabInit(initWorkZoCode, initWorkDoCode, initWorkOfcId);
        getTemplateTitles(initWorkDoCode);
        changeGraphData(
          initTargetDataMap,
          initTableMap["tableHeaderList"],
          initTargetAverageData
        );

        setTmpInitTableMap(cloneMap(initTableMap));
        return;
      }

      // admin-groupの場合のみ初回読み込み時に全検索を行う
      if (!hasManagerAnalysisFullReferencePrivileges(user)) {
        if (isZmCheck(user)) {
          changeTitles(1);
        }
        if (isDmCheck(user)) {
          changeTitles(2);
        }
        return;
      }
    }
    
    // テンプレートタブの場合、週選択オプションを初期化
    if (tabValue === 5) {
      const weeks = getPastWeekMondays(5);
      setWeekOptions(weeks);
      if (!selectedWeek && weeks.length > 0) {
        setSelectedWeek(weeks[0].value);
      }
    }

    userLogging(
      "店舗確認表",
      "管理者分析#データ取得条件",
      "タブ名[" +
        headerName +
        "別分析] ZO[" +
        workZoCode +
        "] DO[" +
        workDoCode +
        "] データ[" +
        workBaseData +
        "] OFC[" +
        ofcId +
        "] 店舗[" +
        tenpoCode +
        "]"
    );

    setExecuteFlg("1");
    getTemplateTitles().then((res: any) => {
      let responseMap: any = res;
      let templateGetMap: any = {};
      if (responseMap) {
        templateGetMap.templatesMap = responseMap.templatesMap;
        templateGetMap.templateItemList = responseMap.templateItemList;
      }
      getTableData(
        String(tabValue + 1),
        workZoCode,
        workDoCode,
        workBaseData || DateTime.local(),
        ofcId,
        tenpoCode,
        templateGetMap
      ).then((res: any) => {
        changeTitles(tabValue);
        let responseMap: any = res;
        userLogging(
          "店舗確認表",
          "管理者分析#データ取得結果",
          JSON.stringify(responseMap)
        );
        if (responseMap) {
          setTargetData(responseMap.dataList);
        }

        updateDisableTab();
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue, updateFlg]);

  // 詳細項目一覧取得
  const getSmallTitles = () => {
    getFirestoreDocData("tenpo_check_items", "000000_basedata").then(
      (response: any) => {
        let initItem = initSmallTitle;
        let smallItems1: any[] = [initItem];
        let smallItems2: any[] = [initItem];
        let smallItems3: any[] = [initItem];
        let smallItems4: any[] = [initItem];
        let smallItems5: any[] = [initItem];
        let smallItems6: any[] = [initItem];
        let smallItems7: any[] = [initItem];

        Object.keys(response.attribution)
          .sort()
          .forEach(function (key) {
            let smallItems: any[] = response.attribution[key].small_items;
            let bigItemId = response.attribution[key].big_item_id;
            for (const row of smallItems) {
              let id = Number(row.id) + 1;
              let name = row.name;
              if (bigItemId === "1") smallItems1.push({ id: id, name: name });
              if (bigItemId === "2") smallItems2.push({ id: id, name: name });
              if (bigItemId === "3") smallItems3.push({ id: id, name: name });
              if (bigItemId === "4") smallItems4.push({ id: id, name: name });
              if (bigItemId === "5") smallItems5.push({ id: id, name: name });
              if (bigItemId === "6") smallItems6.push({ id: id, name: name });
              if (bigItemId === "7") smallItems7.push({ id: id, name: name });
            }
          });
        setSmallTitleList1(smallItems1);
        setSmallTitleList2(smallItems2);
        setSmallTitleList3(smallItems3);
        setSmallTitleList4(smallItems4);
        setSmallTitleList5(smallItems5);
        setSmallTitleList6(smallItems6);
        setSmallTitleList7(smallItems7);
        return;
      }
    );
  };

  // ZOコードを取得する
  const getTemplateZocode: any = async (code: string, type: string) => {
    let tmpZoCode = await getZocodeInfo(code, type);
    setTemplateZoCode(tmpZoCode);
    return tmpZoCode;
  };

  const getWorkTemplateData = async (
    conditions: any,
    workTemplateDataList: any[],
    workTemplateMap: any,
    bigItemId: number
  ) => {
    await getTemplateData(conditions).then((response: any[]) => {
      // テンプレートの各小項目プルダウン
      const templatesMap: any = {};
      for (const templateItem of response) {
        if (templateItem.big_item_id !== bigItemId) {
          continue;
        }
        let workMap = {
          id: templateItem.id,
          big_item_id: templateItem.big_item_id,
          name:
            (bigItemId === 12 ? "【DO】" : 
              bigItemId === 10 ? "【ZO】" : bigItemId === 11 ? "【全国】" : "") +
            templateItem.template_name,
          smallItems: templateItem.small_items,
        };
        templatesMap[templateItem.id] = workMap;
        workTemplateMap[templateItem.id] = workMap;
      }
      // テンプレート一覧プルダウン
      const templateItems: any[] = (Object.entries(templatesMap) as any[]).map(
        ([key, value]) => ({
          id: key,
          name: value.name,
          big_item_id: value.big_item_id,
        })
      );
      for (let i = 0; i < templateItems.length; i++) {
        workTemplateDataList.push(templateItems[i]);
      }
    });
  };

  // テンプレートのソート
  const sortTemplateItemList = (templateList: any[]) => {
    let zenkokuTemplateList: any[] = [];
    let zoTemplateList: any[] = [];
    let doTemplateList: any[] = [];
    let kojinTemplateList: any[] = [];
    for (let templateItem of templateList) {
      if (templateItem.big_item_id === 11) {
        zenkokuTemplateList.push(templateItem);
      } else if (templateItem.big_item_id === 10) {
        zoTemplateList.push(templateItem);
      } else {
        kojinTemplateList.push(templateItem);
      }
    }
    zenkokuTemplateList = zenkokuTemplateList.sort(function (first, second) {
      if (first.name < second.name) {
        return 1;
      } else if (first.name > second.name) {
        return -1;
      } else {
        return 0;
      }
    });

    zoTemplateList = zoTemplateList.sort(function (first, second) {
      if (first.name < second.name) {
        return 1;
      } else if (first.name > second.name) {
        return -1;
      } else {
        return 0;
      }
    });
        
    doTemplateList = doTemplateList.sort(function (first, second) {
      if (first.name < second.name) {
        return 1;
      } else if (first.name > second.name) {
        return -1;
      } else {
        return 0;
      }
    });

    kojinTemplateList = kojinTemplateList.sort(function (first, second) {
      if (first.name < second.name) {
        return 1;
      } else if (first.name > second.name) {
        return -1;
      } else {
        return 0;
      }
    });

    let resultTemplateList: any[] = [];
    for (let templateItem of zenkokuTemplateList) {
      resultTemplateList.push(templateItem);
    }
    for (let templateItem of zoTemplateList) {
      resultTemplateList.push(templateItem);
    }
    for (let templateItem of doTemplateList) {
      resultTemplateList.push(templateItem);
    }
    for (let templateItem of kojinTemplateList) {
      resultTemplateList.push(templateItem);
    }
    return resultTemplateList;
  };

  // 詳細項目一覧取得
  const getTemplateTitles = async (docode?: any) => {
    let resultMap: any = null;
    const conditions: string[] = docode
      ? [docode]
      : workDoCode
      ? [workDoCode]
      : workZoCode
      ? [workZoCode]
      : [];

    let zenkokuFlg = false;
    let zoFlg = false;
    let doFlg = false;
    if (tabValue === 0) {
      zenkokuFlg = true;
    } else if (tabValue === 1 || tabValue === 2 || tabValue === 3 || tabValue === 5) {
      zenkokuFlg = true;
      zoFlg = true;
    }
    if (tabValue === 2 || tabValue === 3 || tabValue === 5) {
      doFlg = true;
    }
    let workTemplateItemList: any[] = [];
    let workTemplateMap: any = {};
    if (zenkokuFlg) {
      await getWorkTemplateData(
        [ZENKOKU_CODE],
        workTemplateItemList,
        workTemplateMap,
        11
      );
    }

    if (zoFlg) {
      let zoCode = null;
      if (tabValue === 2) {
        zoCode = await getTemplateZocode(workDoCode, "doCode");
      } else if (tabValue === 3) {
        if (ofcId) {
          zoCode = await getTemplateZocode(ofcId, "ofcId");
        } else {
          if (initTableMap && initTableMap["ofcId"]) {
            let initWorkOfcId = initTableMap["ofcId"];
            zoCode = await getTemplateZocode(initWorkOfcId, "ofcId");
          }
        }
      }
      if (!zoCode && !templateZoCode) {
        return;
      }
      await getWorkTemplateData(
        [zoCode ? zoCode : templateZoCode],
        workTemplateItemList,
        workTemplateMap,
        10
      );
    }
    if (doFlg) {
      await getWorkTemplateData(
        [workDoCode],
        workTemplateItemList,
        workTemplateMap,
        12
      );
    }

    await getTemplateData(conditions).then((response: any[]) => {
      // テンプレートの各小項目プルダウン
      const templatesMap: any = {};
      for (const templateItem of response) {
        if (templateItem.big_item_id !== 8) {
          continue;
        }
        templatesMap[templateItem.id] = {
          id: templateItem.id,
          big_item_id: templateItem.big_item_id,
          name: templateItem.template_name,
          smallItems: templateItem.small_items,
        };
      }

      // テンプレート一覧プルダウン
      const templateItems: any[] = (Object.entries(templatesMap) as any[]).map(
        ([key, value]) => ({
          id: key,
          name: value.name,
          big_item_id: value.big_item_id,
        })
      );

      workTemplateItemList = sortTemplateItemList(workTemplateItemList);

      let resultTemplateList = [];
      if (tabValue === 3 || tabValue === 5) {
        // 個店別分析・個店別分析(テンプレート)タブの場合
        // 全国・ZO項目と個人テンプレート項目を併せる
        resultTemplateList = [
          initSmallTitle,
          ...workTemplateItemList,
          ...templateItems,
        ];
      } else {
        // その他のタブの場合
        // 全国・ZO項目のみ
        resultTemplateList = [initSmallTitle, ...workTemplateItemList];
      }
      setTemplateItemList(resultTemplateList);

      for (let key in workTemplateMap) {
        templatesMap[workTemplateMap[key]["id"]] = {
          id: workTemplateMap[key]["id"],
          name: workTemplateMap[key]["name"],
          big_item_id: workTemplateMap[key]["big_item_id"],
          smallItems: workTemplateMap[key]["smallItems"],
        };
      }

      setTemplatesMap(templatesMap);
      setClickFlg(!clickFlg);

      resultMap = {};
      resultMap["templatesMap"] = templatesMap;
      resultMap["templateItemList"] = resultTemplateList;

      return resultMap;
    });
    return resultMap;
  };

  // 実行ボタン押下時用useEffect
  useEffect(() => {
    if (initTabValue !== 0 && initFlg) {
      return;
    }
    setTabValue(analysis);
    setIndexTabValue(analysis);
    if (isZmCheck(user)) {
      setIndexTabValue(analysis - 1);
    }
    if (isDmCheck(user)) {
      setIndexTabValue(analysis - 2);
    }
    if (zoCode !== "") {
      setWorkZoCode(zoCode);
      setTemplateZoCode(zoCode);
    }
    if (doCode !== "") {
      setWorkDoCode(doCode);
    }
    // setOfcId("");
    // setTenpoCode("");
    setUpdateFlg(update);
    setWorkBaseData(baseData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update]);

  // 表示するヘッダ名の変更
  const changeTitles = (num: number) => {
    if (num === 0) {
      setHeaderName("ZO");
    }
    if (num === 1) {
      setHeaderName("DO");
    }
    if (num === 2) {
      setHeaderName("OFC");
    }
    if (num === 3) {
      setHeaderName("個店");
    }
    if (num === 5) {
      setHeaderName("個店(テンプレート)");
    }
  };

  //  タブのクリック処理
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setIndexTabValue(newValue);
    if (isZmCheck(user)) {
      newValue = newValue + 1;
    }
    if (isDmCheck(user)) {
      newValue = newValue + 2;
    }

    changeTitles(newValue);
    setTabValue(newValue);
  };

  const dialogClose = () => {
    setDialogFlg(false);
  };

  // タブの活性・非活性更新
  function updateDisableTab() {
    if (hasManagerAnalysisFullReferencePrivileges(user)) {
      setZoTabDisableFlg(false);
    }
    setDoTabDisableFlg(workZoCode ? false : true);
    setOfcTabDisableFlg(workDoCode ? false : true);
    setKobetuTabDisableFlg(ofcId ? false : true);
    setTemplateTabDisableFlg(true);  // 常に無効化
  }
  function updateDisableTabInit(
    initWorkZoCode: string,
    initWorkDoCode: string,
    initOfcId: string
  ) {
    if (hasManagerAnalysisFullReferencePrivileges(user)) {
      setZoTabDisableFlg(false);
    }
    setDoTabDisableFlg(initWorkZoCode ? false : true);
    setOfcTabDisableFlg(initWorkDoCode ? false : true);
    setKobetuTabDisableFlg(initOfcId ? false : true);
    setTemplateTabDisableFlg(true);  // 常に無効化
  }

  // 平均点計算
  function calcAverage(num: any, count: any) {
    if (!num) {
      return 0;
    }
    return Math.round(parseFloat(num) / parseFloat(count));
  }

  // パーセント計算
  function calcPercent(num: any, count: any) {
    if (!num) {
      return 0;
    }
    return Math.round((parseFloat(num) / parseFloat(count)) * 100);
  }
  // 差分計算
  function calcDiff(num1: any, num2: any) {
    let mainScore: number = Number(num1) || 0;
    let diffScore: number = Number(num2) || 0;
    let result: number = 0;
    result = Math.round(mainScore) - Math.round(diffScore);
    result = Math.round(result);

    return result;
  }
  // コード順に並べ変え
  function sortCode(dataMapList: any[]) {
    let mapList: any[] = dataMapList;

    if (tabValue === 2) {
      return mapList.sort(function (first, second) {
        if (first.sortDoCode > second.sortDoCode) {
          return 1;
        } else if (first.sortDoCode < second.sortDoCode) {
          return -1;
        } else {
          if (first.sortOfcCode > second.sortOfcCode) {
            return 1;
          } else if (first.sortOfcCode < second.sortOfcCode) {
            return -1;
          } else {
            return 0;
          }
        }
      });
    } else if (tabValue === 3) {
      return mapList.sort(function (first, second) {
        if (first.sortOfcCode > second.sortOfcCode) {
          return 1;
        } else if (first.sortOfcCode < second.sortOfcCode) {
          return -1;
        } else {
          if (first.code > second.code) {
            return 1;
          } else if (first.code < second.code) {
            return -1;
          } else {
            return 0;
          }
        }
      });
    } else {
      return mapList.sort(function (first, second) {
        if (first.code > second.code) {
          return 1;
        } else if (first.code < second.code) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  }
  // 総数計算の対象判断
  const countTotalTarget = (score: any) => {
    let value: number = Number(score);
    if (value === 0) {
      return 0;
    } else {
      return 1;
    }
  };
  // 小数点以下を四捨五入
  const roundOffDecimal = (num: any) => {
    let value: number = Number(num);
    if (value) {
      return Math.round(value);
    }
    return 0;
  };

  // データ取得(API)
  const getData = (
    analysis: string,
    zoCode: string,
    doCode: string,
    target_date: DateTime,
    ofc_id: string,
    tenpo_code: string,
    templateGetMap: any
  ) => {
    let workAnalysis = String(analysis);                            
    if (allDoFlg && workAnalysis === ANALYSIS_TYPES.STORE_ANALYSIS) {
      workAnalysis = ANALYSIS_TYPES.DO_STORE_ANALYSIS;
    }

    // アクセスログを送信（分析タイプに応じて）
    if (workAnalysis === ANALYSIS_TYPES.STORE_ANALYSIS) {
      sendTenpoCheckStoreAnalysisAccessLog();
    } else if (workAnalysis === ANALYSIS_TYPES.DO_STORE_ANALYSIS) {
      sendTenpoCheckDoAllStoreAnalysisAccessLog();
    }

    const apiParams = {
      "api-name": "analysis",
      target_date: target_date.toFormat("yyyy/MM/dd HH:mm:ss"),
      zo_code: workZoCode,
      do_code: workDoCode,
      ofc_id: ofc_id,
      tenpo_code: tenpo_code,
      analysis: workAnalysis,
    };

    let selectList: any[] = [];
    selectList.push({ id: 1, name: "総合" });
    for (let i = 0; i < tableHeaderList2.length; i++) {
      selectList.push({ id: i + 2, name: tableHeaderList2[i] });
    }
    setTableList(selectList);
    setExecuteFlg("1");
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "tenpocheck/analysis";
    return postRequest(url, apiParams)
      .then((res) => {
        let dataList: any[] = res.data.dataList;
        let dispatchDateMap: any = {};

        setSelectedBaseDate(null);
        setSelectedSmallBaseDate(null);
        setBaseWeek("");
        setSmallBaseWeek("");
        if (dataList) {
          // 画面入力初期化
          setGraphUserList([]);
          // テンプレートタブの場合は、selectedTableを"9"に保持
          if (tabValue !== 5) {
            setSelectedTable("1");
            setSelectedSmallTitle("1");
            setSmallTitleList([initSmallTitle, initSmallTitle2, initSmallTitle3]);
          } else {
            // テンプレートタブの場合
            setSelectedTable("9");
            setSelectedSmallTitle("1");
            setSmallTitleList(templateItemList);
          }
          setSelectedSmallFlg(false);
          // テンプレートタブの場合は初期状態でtargetDataをtargetData8に設定
          if (tabValue === 5) {
            // テンプレート用のデータ構造を作成
            const templateData = targetData8.map((row) => {
              const templateRow: any = {
                ...row,
                ofcName: row.ofcName || "",
              };

              return templateRow;
            });

            setTargetData(templateData);
            setTargetAverageData(targetAverageData8);
          }
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];
            let averageScoreBreakdown: any[] =
              datajsList.average_score_breakdown;

            let weekValue: any = datajsList.week_value[0].week;
            let submissionWeekValue: any =
              datajsList.week_value[0].submission_week;
            let headerList = [];
            // 合計値用インターフェイス
            interface totalMap {
              "1w": number;
              "2w": number;
              "3w": number;
              "4w": number;
              "5w": number;
              "6w": number;
            }
            const initTotalMap = () => {
              let map: totalMap = {
                "1w": 0,
                "2w": 0,
                "3w": 0,
                "4w": 0,
                "5w": 0,
                "6w": 0,
              };
              return map;
            };
            // 合計値加算
            const addTotals = (
              map: totalMap,
              num1: any,
              num2: any,
              num3: any,
              num4: any,
              num5: any,
              num6?: any
            ) => {
              map["1w"] += roundOffDecimal(num1);
              map["2w"] += roundOffDecimal(num2);
              map["3w"] += roundOffDecimal(num3);
              map["4w"] += roundOffDecimal(num4);
              map["5w"] += roundOffDecimal(num5);
              // 0week
              map["6w"] += roundOffDecimal(num6);
            };
            // 地区平均の作成
            const makeAverage = (
              totalScore: totalMap,
              countList: number[],
              headerList: any[]
            ) => {
              let averageMap: any = {
                name: "地区平均／" + averageTitle + "平均",
                code: "average",
              };
              // totalには5～1が逆に入っている 6は別
              let average1 = calcAverage(totalScore["1w"], countList[0]);
              let average2 = calcAverage(totalScore["2w"], countList[1]);
              let average3 = calcAverage(totalScore["3w"], countList[2]);
              let average4 = calcAverage(totalScore["4w"], countList[3]);
              let average5 = calcAverage(totalScore["5w"], countList[4]);
              let average6 = calcAverage(totalScore["6w"], countList[5]);

              averageMap[headerList[0]] = average1;
              averageMap[headerList[1]] = average2;
              averageMap[headerList[2]] = average3;
              averageMap[headerList[3]] = average4;
              averageMap[headerList[4]] = average5;
              averageMap["1wDiff"] = calcDiff(average6, average1);
              averageMap["2wDiff"] = calcDiff(average2, average1);
              averageMap["3wDiff"] = calcDiff(average3, average2);
              averageMap["4wDiff"] = calcDiff(average4, average3);
              averageMap["5wDiff"] = calcDiff(average5, average4);
              return averageMap;
            };

            const dataMapCreate = (
              dataMap: any,
              headerList: any[],
              no: number,
              resultMap: any
            ) => {
              let map: any = {
                name: dataMap.name,
                code: dataMap.code,
                sortDoCode: dataMap.sortDoCode,
                sortOfcCode: dataMap.sortOfcCode,
                ofcName: dataMap.ofcName,
              };
              let key = "";
              if (no === 9 || no === 10) {
                if (no === 9) key = "comment_count";
                if (no === 10) key = "file_count";
              } else {
                key = "score" + no;
              }
              map[headerList[4]] = roundOffDecimal(resultMap.result1[key]);
              map[headerList[3]] = roundOffDecimal(resultMap.result2[key]);
              map[headerList[2]] = roundOffDecimal(resultMap.result3[key]);
              map[headerList[1]] = roundOffDecimal(resultMap.result4[key]);
              map[headerList[0]] = roundOffDecimal(resultMap.result5[key]);
              map["5wDiff"] = calcDiff(
                resultMap.result1[key],
                resultMap.result2[key]
              );
              map["4wDiff"] = calcDiff(
                resultMap.result2[key],
                resultMap.result3[key]
              );
              map["3wDiff"] = calcDiff(
                resultMap.result3[key],
                resultMap.result4[key]
              );
              map["2wDiff"] = calcDiff(
                resultMap.result4[key],
                resultMap.result5[key]
              );
              map["1wDiff"] = calcDiff(
                resultMap.result5[key],
                resultMap.result6[key]
              );
              return map;
            };

            // 週名称の設定
            if (weekValue) {
              headerList.push(weekValue.week5 + "週");
              headerList.push(weekValue.week4 + "週");
              headerList.push(weekValue.week3 + "週");
              headerList.push(weekValue.week2 + "週");
              headerList.push(weekValue.week1 + "週");

              setTableHeaderList(headerList);
              dispatchDateMap["tableHeaderList"] = headerList;
            }
            // 提出数用週
            if (submissionWeekValue) {
              let list: string[] = [];
              list.push(submissionWeekValue.week5);
              list.push(submissionWeekValue.week4);
              list.push(submissionWeekValue.week3);
              list.push(submissionWeekValue.week2);
              list.push(submissionWeekValue.week1);
              setTableSubmissionHeaderList(list);
              dispatchDateMap["tableSubmissionHeaderList"] = list;
            }

            // 統合の設定
            let averageTitle = "";
            if (tabValue === 0) {
              averageTitle = "ZO";
            } else if (tabValue === 1) {
              averageTitle = "DO";
            } else if (tabValue === 2) {
              averageTitle = "OFC";
            } else if (tabValue === 3) {
              averageTitle = "個別";
            }
            let totalScore0: totalMap = initTotalMap();
            let week1Count = 0;
            let week2Count = 0;
            let week3Count = 0;
            let week4Count = 0;
            let week5Count = 0;
            let week6Count = 0;

            // 項目別の設定
            let scoreList0: any[] = [];
            let scoreList1: any[] = [];
            let scoreList2: any[] = [];
            let scoreList3: any[] = [];
            let scoreList4: any[] = [];
            let scoreList5: any[] = [];
            let scoreList6: any[] = [];
            let scoreList7: any[] = [];
            let scoreList8: any[] = [];
            let scoreListCommentCount: any[] = [];
            let scoreListFileCount: any[] = [];
            let totalScore1: totalMap = initTotalMap();
            let totalScore2: totalMap = initTotalMap();
            let totalScore3: totalMap = initTotalMap();
            let totalScore4: totalMap = initTotalMap();
            let totalScore5: totalMap = initTotalMap();
            let totalScore6: totalMap = initTotalMap();
            let totalScore7: totalMap = initTotalMap();
            let totalScore8: totalMap = initTotalMap();
            let totalScoreCommentCount: totalMap = initTotalMap();
            let totalScoreFileCount: totalMap = initTotalMap();

            for (let j = 0; j < averageScoreBreakdown.length; j++) {
              let name = averageScoreBreakdown[j].codeName.name;
              let code = averageScoreBreakdown[j].codeName.code;
              let sortDoCode = averageScoreBreakdown[j].codeName.sort_docode;
              let sortOfcCode = averageScoreBreakdown[j].codeName.sort_ofc_code;
              let ofcName = averageScoreBreakdown[j].codeName.ofc_name;
              const submissionWeek = averageScoreBreakdown[j].submissionWeek;

              let result1 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result1
                  ? averageScoreBreakdown[j].result1
                  : "";
              let result2 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result2
                  ? averageScoreBreakdown[j].result2
                  : "";
              let result3 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result3
                  ? averageScoreBreakdown[j].result3
                  : "";
              let result4 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result4
                  ? averageScoreBreakdown[j].result4
                  : "";
              let result5 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result5
                  ? averageScoreBreakdown[j].result5
                  : "";
              let result6 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result6
                  ? averageScoreBreakdown[j].result6
                  : "";
              let map: any = { name, code, sortDoCode, sortOfcCode, ofcName };
              let resultMap = {
                result1,
                result2,
                result3,
                result4,
                result5,
                result6,
              };

              week1Count += countTotalTarget(result5.recordCount1);
              week2Count += countTotalTarget(result4.recordCount1);
              week3Count += countTotalTarget(result3.recordCount1);
              week4Count += countTotalTarget(result2.recordCount1);
              week5Count += countTotalTarget(result1.recordCount1);
              week6Count += countTotalTarget(result6.recordCount1);

              addTotals(
                totalScore0,
                result5.score0,
                result4.score0,
                result3.score0,
                result2.score0,
                result1.score0
              );
              addTotals(
                totalScore1,
                result5.score1,
                result4.score1,
                result3.score1,
                result2.score1,
                result1.score1
              );
              addTotals(
                totalScore2,
                result5.score2,
                result4.score2,
                result3.score2,
                result2.score2,
                result1.score2
              );
              addTotals(
                totalScore3,
                result5.score3,
                result4.score3,
                result3.score3,
                result2.score3,
                result1.score3
              );
              addTotals(
                totalScore4,
                result5.score4,
                result4.score4,
                result3.score4,
                result2.score4,
                result1.score4
              );
              addTotals(
                totalScore5,
                result5.score5,
                result4.score5,
                result3.score5,
                result2.score5,
                result1.score5
              );
              addTotals(
                totalScore6,
                result5.score6,
                result4.score6,
                result3.score6,
                result2.score6,
                result1.score6
              );
              addTotals(
                totalScore7,
                result5.score7,
                result4.score7,
                result3.score7,
                result2.score7,
                result1.score7
              );
              addTotals(
                totalScore8,
                result5.score8,
                result4.score8,
                result3.score8,
                result2.score8,
                result1.score8
              );
              addTotals(
                totalScoreCommentCount,
                result5.comment_count,
                result4.comment_count,
                result3.comment_count,
                result2.comment_count,
                result1.comment_count
              );
              addTotals(
                totalScoreFileCount,
                result5.file_count,
                result4.file_count,
                result3.file_count,
                result2.file_count,
                result1.file_count
              );

              if (tabValue === 2 || tabValue === 3) {
                scoreList0.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 0, resultMap),
                    submissionWeek
                  )
                );
                scoreList1.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 1, resultMap),
                    submissionWeek
                  )
                );
                scoreList2.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 2, resultMap),
                    submissionWeek
                  )
                );
                scoreList3.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 3, resultMap),
                    submissionWeek
                  )
                );
                scoreList4.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 4, resultMap),
                    submissionWeek
                  )
                );
                scoreList5.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 5, resultMap),
                    submissionWeek
                  )
                );
                scoreList6.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 6, resultMap),
                    submissionWeek
                  )
                );
                scoreList7.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 7, resultMap),
                    submissionWeek
                  )
                );
                scoreList8.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 8, resultMap),
                    submissionWeek
                  )
                );
                scoreListCommentCount.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 9, resultMap),
                    submissionWeek
                  )
                );
                scoreListFileCount.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 10, resultMap),
                    submissionWeek
                  )
                );
              } else {
                scoreList0.push(dataMapCreate(map, headerList, 0, resultMap));
                scoreList1.push(dataMapCreate(map, headerList, 1, resultMap));
                scoreList2.push(dataMapCreate(map, headerList, 2, resultMap));
                scoreList3.push(dataMapCreate(map, headerList, 3, resultMap));
                scoreList4.push(dataMapCreate(map, headerList, 4, resultMap));
                scoreList5.push(dataMapCreate(map, headerList, 5, resultMap));
                scoreList6.push(dataMapCreate(map, headerList, 6, resultMap));
                scoreList7.push(dataMapCreate(map, headerList, 7, resultMap));
                scoreList8.push(dataMapCreate(map, headerList, 8, resultMap));
                scoreListCommentCount.push(
                  dataMapCreate(map, headerList, 9, resultMap)
                );
                scoreListFileCount.push(
                  dataMapCreate(map, headerList, 10, resultMap)
                );
              }
            }

            let countList: any[] = [];
            countList.push(week1Count);
            countList.push(week2Count);
            countList.push(week3Count);
            countList.push(week4Count);
            countList.push(week5Count);
            countList.push(week6Count);
            // 地区平均
            let averageMap0 = makeAverage(totalScore0, countList, headerList);
            let averageMap1 = makeAverage(totalScore1, countList, headerList);
            let averageMap2 = makeAverage(totalScore2, countList, headerList);
            let averageMap3 = makeAverage(totalScore3, countList, headerList);
            let averageMap4 = makeAverage(totalScore4, countList, headerList);
            let averageMap5 = makeAverage(totalScore5, countList, headerList);
            let averageMap6 = makeAverage(totalScore6, countList, headerList);
            let averageMap7 = makeAverage(totalScore7, countList, headerList);
            let averageMap8 = makeAverage(totalScore8, countList, headerList);
            let averageMapCommentCount = makeAverage(
              totalScoreCommentCount,
              countList,
              headerList
            );
            let averageMapFileCount = makeAverage(
              totalScoreFileCount,
              countList,
              headerList
            );
            setTargetAverageData(averageMap0);
            setTargetAverageData0(averageMap0);
            setTargetAverageData1(averageMap1);
            setTargetAverageData2(averageMap2);
            setTargetAverageData3(averageMap3);
            setTargetAverageData4(averageMap4);
            setTargetAverageData5(averageMap5);
            setTargetAverageData6(averageMap6);
            setTargetAverageData7(averageMap7);
            setTargetAverageData8(averageMap8);
            setTargetAverageDataCommentCount(averageMapCommentCount);
            setTargetAverageDataFileCount(averageMapFileCount);

            setTargetData0(sortCode(scoreList0));
            setTargetData1(sortCode(scoreList1));
            setTargetData2(sortCode(scoreList2));
            setTargetData3(sortCode(scoreList3));
            setTargetData4(sortCode(scoreList4));
            setTargetData5(sortCode(scoreList5));
            setTargetData6(sortCode(scoreList6));
            setTargetData7(sortCode(scoreList7));
            setTargetData8(sortCode(scoreList8));
            setTargetDataCommentCount(sortCode(scoreListCommentCount));
            setTargetDataFileCount(sortCode(scoreListFileCount));

            // テンプレートタブの場合はtargetDataを更新
            if (tabValue === 5) {
              setTargetData(sortCode(scoreList8));
              setTargetAverageData(averageMap8);
            }

            dispatchDateMap["targetList0"] = cloneListMap(sortCode(scoreList0));
            dispatchDateMap["targetList1"] = cloneListMap(sortCode(scoreList1));
            dispatchDateMap["targetList2"] = cloneListMap(sortCode(scoreList2));
            dispatchDateMap["targetList3"] = cloneListMap(sortCode(scoreList3));
            dispatchDateMap["targetList4"] = cloneListMap(sortCode(scoreList4));
            dispatchDateMap["targetList5"] = cloneListMap(sortCode(scoreList5));
            dispatchDateMap["targetList6"] = cloneListMap(sortCode(scoreList6));
            dispatchDateMap["targetList7"] = cloneListMap(sortCode(scoreList7));
            dispatchDateMap["targetList8"] = cloneListMap(sortCode(scoreList8));
            dispatchDateMap["targetListCommentCount"] = cloneListMap(
              sortCode(scoreListCommentCount)
            );
            dispatchDateMap["targetListFileCount"] = cloneListMap(
              sortCode(scoreListFileCount)
            );
            dispatchDateMap["targetAverageData0"] = cloneMap(averageMap0);
            dispatchDateMap["targetAverageData1"] = cloneMap(averageMap1);
            dispatchDateMap["targetAverageData2"] = cloneMap(averageMap2);
            dispatchDateMap["targetAverageData3"] = cloneMap(averageMap3);
            dispatchDateMap["targetAverageData4"] = cloneMap(averageMap4);
            dispatchDateMap["targetAverageData5"] = cloneMap(averageMap5);
            dispatchDateMap["targetAverageData6"] = cloneMap(averageMap6);
            dispatchDateMap["targetAverageData7"] = cloneMap(averageMap7);
            dispatchDateMap["targetAverageData8"] = cloneMap(averageMap8);
            dispatchDateMap["targetAverageDataCommentCount"] = cloneMap(
              averageMapCommentCount
            );
            dispatchDateMap["targetAverageDataFileCount"] =
              cloneMap(averageMapFileCount);
            dispatchDateMap["tableList"] = selectList;
            dispatchDateMap["workZoCode"] = workZoCode;
            dispatchDateMap["workDoCode"] = workDoCode;
            dispatchDateMap["ofcId"] = ofc_id;
            dispatchDateMap["tenpoCode"] = tenpo_code;

            if (templateGetMap) {
              dispatchDateMap["templatesMap"] = cloneMap(
                templateGetMap.templatesMap
                  ? templateGetMap.templatesMap
                  : templateItemList
              );
              dispatchDateMap["templateItemList"] = cloneListMap(
                templateGetMap.templateItemList
                  ? templateGetMap.templateItemList
                  : templateItemList
              );
            } else {
              dispatchDateMap["templatesMap"] = cloneMap(templateItemList);
              dispatchDateMap["templateItemList"] =
                cloneListMap(templateItemList);
            }

            dispatchDateMap["allDoFlg"] = allDoFlg;
            dispatchDateMap["indexTabValue"] = indexTabValue;
            // テンプレートタブの場合は、selectedTableを"9"に設定
            dispatchDateMap["selectedTable"] = tabValue === 5 ? "9" : "1";
            dispatchDateMap["selectedSmallTable"] = "1";
            dispatchDateMap["selectedTemplateSmallTitle"] = "0";
            dispatchDateMap["selectedSmallFlg"] = false;
            dispatchDateMap["workZoCode"] = workZoCode;
            dispatchDateMap["workDoCode"] = workDoCode;
            dispatchDateMap["templateZoCode"] = templateZoCode;

            dispatch(
              updateTenpoCheckManagerMap({
                tenpoCheckManagerMap: dispatchDateMap,
              })
            );

            dispatch(
              updateTenpoCheckManagerTab({
                tenpoCheckManagerTab: tabValue,
              })
            );
            setTmpInitTableMap(dispatchDateMap);

            return {
              weekList: scoreList0,
              headerList,
              averageMap: averageMap0,
            };
          }
        }
      })
      .catch((r) => {
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      })
      .finally(() => {
        setExecuteFlg("");
      });
  };

  // グラフ用の値を補足
  const getTableData = async (
    analysis: string,
    zoCode: string,
    doCode: string,
    target_date: DateTime,
    ofc_id: string,
    tenpo_code: string,
    templateGetMap: any
  ) => {
    let resultMap: any = {};
    let result = await getData(
      analysis,
      zoCode,
      doCode,
      target_date,
      ofc_id,
      tenpo_code,
      templateGetMap
    );
    let dataList: any[] = [];
    if (result) {
      resultMap = result;
      dataList = result.weekList;
      let headerList = result.headerList;
      let averageMap = result.averageMap;
      changeGraphData(dataList, headerList, averageMap);
    }
    resultMap["dataList"] = dataList;

    return resultMap;
  };

  // グラフの設定
  function changeGraphData(
    dataList: any[],
    headerList: any[],
    averageMap: any
  ) {
    let weekMap_1: any = {};
    let weekMap_2: any = {};
    let weekMap_3: any = {};
    let weekMap_4: any = {};
    let weekMap_5: any = {};
    let graphDataList = [];

    if (dataList) {
      for (let i = 0; i < dataList.length; i++) {
        weekMap_1[dataList[i].name] = dataList[i][headerList[0]];
        weekMap_2[dataList[i].name] = dataList[i][headerList[1]];
        weekMap_3[dataList[i].name] = dataList[i][headerList[2]];
        weekMap_4[dataList[i].name] = dataList[i][headerList[3]];
        weekMap_5[dataList[i].name] = dataList[i][headerList[4]];
      }
      if (averageMap) {
        weekMap_1[averageMap.name] = averageMap[headerList[0]];
        weekMap_2[averageMap.name] = averageMap[headerList[1]];
        weekMap_3[averageMap.name] = averageMap[headerList[2]];
        weekMap_4[averageMap.name] = averageMap[headerList[3]];
        weekMap_5[averageMap.name] = averageMap[headerList[4]];
      }
    }

    for (let j = 0; j < headerList.length; j++) {
      if (j === 0) weekMap_1["week"] = headerList[j];
      if (j === 1) weekMap_2["week"] = headerList[j];
      if (j === 2) weekMap_3["week"] = headerList[j];
      if (j === 3) weekMap_4["week"] = headerList[j];
      if (j === 4) weekMap_5["week"] = headerList[j];
    }
    graphDataList.push(weekMap_1);
    graphDataList.push(weekMap_2);
    graphDataList.push(weekMap_3);
    graphDataList.push(weekMap_4);
    graphDataList.push(weekMap_5);

    setTargetGraphData(graphDataList);
  }

  // ZO名、DO名、OFC名のクリック
  const moveClick = (code: string) => {
    let minusIndex = 0;
    setAllDoFlg(false);
    if (isZmCheck(user)) {
      minusIndex = 1;
    }
    if (isDmCheck(user)) {
      minusIndex = 2;
    }
    if (tabValue === 0) {
      setWorkZoCode(code);
      setTemplateZoCode(code);
      // 下層タブのクリア
      setWorkDoCode("");
      setOfcId("");
      setTenpoCode("");
      setIndexTabValue(1 - minusIndex);
      setTabValue(1);
    }
    if (tabValue === 1) {
      setWorkDoCode("00" + code);
      getTemplateZocode(code, "doCode");
      setOfcId("");
      setTenpoCode("");
      setIndexTabValue(2 - minusIndex);
      setTabValue(2);
    }
    if (tabValue === 2) {
      getTemplateZocode(code, "ofcId");
      setOfcId(code);
      setTenpoCode("");
      setIndexTabValue(3 - minusIndex);
      setTabValue(3);
    }
    if (tabValue === 3) {
      setTenpoCode(code);
      setIndexTabValue(4 - minusIndex);
      setTabValue(4);
    }
  };

  // ZO名、DO名、OFC名のクリック
  const moveClickDMAll = () => {
    let minusIndex = 0;
    setAllDoFlg(true);
    if (isZmCheck(user)) {
      minusIndex = 1;
    }
    if (isDmCheck(user)) {
      minusIndex = 2;
    }
    if (tabValue === 2) {
      // setTenpoCode(code);
      setIndexTabValue(3 - minusIndex);
      setTabValue(3);
    }
  };

  // DO内個店別分析(テンプレート)ボタンのクリック
  const moveClickDMAllTemplate = () => {
    let minusIndex = 0;
    setAllDoFlg(true);
    if (isZmCheck(user)) {
      minusIndex = 1;
    }
    if (isDmCheck(user)) {
      minusIndex = 2;
    }
    if (tabValue === 2) {
      // DO内個店別分析(テンプレート)ボタン押下時のアクセスログを送信
      sendTenpoCheckDoTemplateAnalysisAccessLog();
      setIndexTabValue(4 - minusIndex);
      setTabValue(5); // 新しいテンプレートタブへ
    }
  };

  // 選択ボタンのクリック
  const selectClick = (code: string, name: string) => {
    let addFlg = true;
    let userList = [];
    let cnt = 0;
    for (let i = 0; i < graphUserList.length; i++) {
      cnt += 1;
      if (code === graphUserList[i].code) {
        addFlg = false;
        continue;
      }
      userList.push(graphUserList[i]);
    }
    let colorNumber = cnt % 10;
    if (addFlg) {
      userList.push({ code, name, fill: fillCodeList[colorNumber] });
    }
    setGraphUserList(userList);
  };

  //　表示区分のセレクトボックス変更時の処理
  const doSelChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    let val: string = String(event.target.value);
    setSelectedTable(val);
    setSelectedSmallTitle("1");
    setSelectedSmallFlg(false);
    let smallTitleList = [];
    if (val === "1") {
      setTargetAverageData(targetAverageData0);
      setTargetData(targetData0);
      setSmallTitleList([initSmallTitle, initSmallTitle2, initSmallTitle3]);
      smallTitleList = [initSmallTitle, initSmallTitle2, initSmallTitle3];
      changeGraphData(targetData0, tableHeaderList, targetAverageData0);
    }
    if (val === "2") {
      setTargetAverageData(targetAverageData1);
      setTargetData(targetData1);
      setSmallTitleList(smallTitleList1);
      smallTitleList = smallTitleList1;
      changeGraphData(targetData1, tableHeaderList, targetAverageData1);
    }
    if (val === "3") {
      setTargetAverageData(targetAverageData2);
      setTargetData(targetData2);
      setSmallTitleList(smallTitleList2);
      smallTitleList = smallTitleList2;
      changeGraphData(targetData2, tableHeaderList, targetAverageData2);
    }
    if (val === "4") {
      setTargetAverageData(targetAverageData3);
      setTargetData(targetData3);
      setSmallTitleList(smallTitleList3);
      smallTitleList = smallTitleList3;
      changeGraphData(targetData3, tableHeaderList, targetAverageData3);
    }
    if (val === "5") {
      setTargetAverageData(targetAverageData4);
      setTargetData(targetData4);
      setSmallTitleList(smallTitleList4);
      smallTitleList = smallTitleList4;
      changeGraphData(targetData4, tableHeaderList, targetAverageData4);
    }
    if (val === "6") {
      setTargetAverageData(targetAverageData5);
      setTargetData(targetData5);
      setSmallTitleList(smallTitleList5);
      smallTitleList = smallTitleList5;
      changeGraphData(targetData5, tableHeaderList, targetAverageData5);
    }
    if (val === "7") {
      setTargetAverageData(targetAverageData6);
      setTargetData(targetData6);
      setSmallTitleList(smallTitleList6);
      smallTitleList = smallTitleList6;
      changeGraphData(targetData6, tableHeaderList, targetAverageData6);
    }
    if (val === "8") {
      setTargetAverageData(targetAverageData7);
      setTargetData(targetData7);
      setSmallTitleList(smallTitleList7);
      smallTitleList = smallTitleList7;
      changeGraphData(targetData7, tableHeaderList, targetAverageData7);
    }
    if (val === "9") {
      setTargetAverageData(targetAverageData8);
      setTargetData(targetData8);
      setSmallTitleList(templateItemList);
      smallTitleList = templateItemList;
      changeGraphData(targetData8, tableHeaderList, targetAverageData8);
    }

    let tmpMap: any = cloneMap(tmpInitTableMap);
    tmpMap["selectedTable"] = val;
    tmpMap["selectedSmallFlg"] = false;
    tmpMap["selectedSmallTable"] = "1";
    tmpMap["selectedTemplateSmallTitle"] = "0";
    tmpMap["smallTitleList"] = smallTitleList;
    dispatch(
      updateTenpoCheckManagerMap({
        tenpoCheckManagerMap: tmpMap,
      })
    );
    setTmpInitTableMap(cloneMap(tmpMap));
    setTabValue(tabValue);
  };

  //　小項目区分のセレクトボックス変更時の処理
  const doSmallSelChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    let val: string = String(event.target.value);
    console.log("doSmallSelChange - val:", val);
    console.log("doSmallSelChange - selectedTable:", selectedTable);
    console.log("doSmallSelChange - templatesMap:", templatesMap);
    
    setSelectedSmallTitle(val);
    if (val === "1" || val === "101" || val === "102") {
      setSelectedSmallFlg(false);
      if (selectedTable === "1") {
        setTargetAverageData(targetAverageData0);
        setTargetData(targetData0);
        changeGraphData(targetData0, tableHeaderList, targetAverageData0);
      }
      if (selectedTable === "2") {
        setTargetAverageData(targetAverageData1);
        setTargetData(targetData1);
        changeGraphData(targetData1, tableHeaderList, targetAverageData1);
      }
      if (selectedTable === "3") {
        setTargetAverageData(targetAverageData2);
        setTargetData(targetData2);
        changeGraphData(targetData2, tableHeaderList, targetAverageData2);
      }
      if (selectedTable === "4") {
        setTargetAverageData(targetAverageData3);
        setTargetData(targetData3);
        changeGraphData(targetData3, tableHeaderList, targetAverageData3);
      }
      if (selectedTable === "5") {
        setTargetAverageData(targetAverageData4);
        setTargetData(targetData4);
        changeGraphData(targetData4, tableHeaderList, targetAverageData4);
      }
      if (selectedTable === "6") {
        setTargetAverageData(targetAverageData5);
        setTargetData(targetData5);
        changeGraphData(targetData5, tableHeaderList, targetAverageData5);
      }
      if (selectedTable === "7") {
        setTargetAverageData(targetAverageData6);
        setTargetData(targetData6);
        changeGraphData(targetData6, tableHeaderList, targetAverageData6);
      }
      if (selectedTable === "8") {
        setTargetAverageData(targetAverageData7);
        setTargetData(targetData7);
        changeGraphData(targetData7, tableHeaderList, targetAverageData7);
      }
      if (selectedTable === "9") {
        setTargetAverageData(targetAverageData8);
        setTargetData(targetData8);
        changeGraphData(targetData8, tableHeaderList, targetAverageData8);
      }
      if (val === "101") {
        setTargetAverageData(targetAverageDataCommentCount);
        setTargetData(targetDataCommentCount);
        changeGraphData(
          targetDataCommentCount,
          tableHeaderList,
          targetAverageDataCommentCount
        );
      }
      if (val === "102") {
        setTargetAverageData(targetAverageDataFileCount);
        setTargetData(targetDataFileCount);
        changeGraphData(
          targetDataFileCount,
          tableHeaderList,
          targetAverageDataFileCount
        );
      }

      let tmpMap: any = cloneMap(tmpInitTableMap);
      tmpMap["selectedSmallTable"] = val;
      tmpMap["selectedSmallFlg"] = false;
      dispatch(
        updateTenpoCheckManagerMap({
          tenpoCheckManagerMap: tmpMap,
        })
      );
      setTmpInitTableMap(cloneMap(tmpMap));
    } else {
      let tmpTemplateSmallItemList = [];
      if (selectedTable === "9") {
        console.log("doSmallSelChange - selectedTable is 9");
        console.log("doSmallSelChange - templatesMap[val]:", templatesMap[val]);
        if (templatesMap[val]) {
          setTemplateSmallItemList(templatesMap[val].smallItems);
          tmpTemplateSmallItemList = templatesMap[val].smallItems;
          setSelectedTemplateSmallTitle("0");
          setSelectedTemplateBigItemId(templatesMap[val].big_item_id);
          console.log("doSmallSelChange - smallItems:", templatesMap[val].smallItems);
          let tmpMap: any = cloneMap(tmpInitTableMap);
          tmpMap["selectedSmallTable"] = val;
          tmpMap["selectedTemplateSmallTitle"] = "0";
          tmpMap["templateSmallItemList"] = cloneListMap(
            tmpTemplateSmallItemList
          );
          tmpMap["smallTitleList"] = smallTitleList;
          dispatch(
            updateTenpoCheckManagerMap({
              tenpoCheckManagerMap: tmpMap,
            })
          );
          setTmpInitTableMap(cloneMap(tmpMap));
        }
      } else {
        setSmallBaseWeek("");
        setSelectedSmallBaseDate(null);
        setSelectedSmallFlg(true);
        getSmallData(
          workBaseData || DateTime.local(),
          Number(selectedTable) - 1,
          Number(val) - 1
        );
        changeGraphData([], tableHeaderList, "");
      }
    }
  };

  //　テンプレート小項目区分のセレクトボックス変更時の処理
  const doTemplateSmallSelChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    let val: string = String(event.target.value);
    setSelectedTemplateSmallTitle(val);
    setSelectedSmallFlg(true);
    if (val) {
      setSmallBaseWeek("");
      setSelectedSmallBaseDate(null);
      setSelectedSmallFlg(true);
      const selectRow: any[] = templateSmallItemList.filter(
        (rowItem) => rowItem.id === Number(val)
      );

      let bigItemId = Number(selectedTable) - 1;
      if (selectedTemplateBigItemId) {
        bigItemId = Number(selectedTemplateBigItemId);
      }
      getSmallData(
        workBaseData || DateTime.local(),
        bigItemId,
        Number(val) - 1,
        selectRow[0].name,
        selectRow[0].uuid
      );
      setSelectedTemplateItemName(selectRow[0].name);
      setSelectedTemplateItemUuid(selectRow[0].uuid);
      changeGraphData([], tableHeaderList, "");
    }
  };

  // 基準週の取得
  function getFirstDayOfWeek(target_date: string, addDate: number) {
    // 日付取得
    let today = zonedTimeToUtc(target_date, "Asia/Tokyo");
    let this_year = today.getFullYear();
    let this_month = today.getMonth();
    let date = today.getDate();
    let day_num = today.getDay();
    // Sunday - Saturday : 0 - 6
    if (day_num === 0) {
      day_num = 7;
    }
    let this_monday = date - day_num + 1 + addDate;

    //月曜日の年月日
    let firstDayOfWeek = new Date(this_year, this_month, this_monday);
    let month = firstDayOfWeek.getMonth() + 1;
    let day = firstDayOfWeek.getDate();
    if (!month || !day) {
      return "";
    }
    //文字列を作成
    return month + "月" + day + "日週";
  }

  // 基準日の選択
  const handleBaseDate = (date: DateTime | null) => {
    if (
      selectedSmallFlg &&
      selectedTable !== "101" &&
      selectedTable !== "102"
    ) {
      if (date) {
        let baseWeek = getFirstDayOfWeek(date.toFormat("yyyyMMdd"), 0);
        setSmallBaseWeek(baseWeek);
        getSmallBaseDate(date);
      } else {
        updataSmallBaseDataInit();
        setSmallBaseWeek("");
      }
      setSelectedSmallBaseDate(date);
      return date;
    } else {
      if (date) {
        let baseWeek = getFirstDayOfWeek(date.toFormat("yyyyMMdd"), 0);
        setBaseWeek(baseWeek);
        updateBaseDate(date);
      } else {
        setSelectedTable("1");
        setSmallTitleList([initSmallTitle, initSmallTitle2, initSmallTitle3]);
        updataBaseDataInit();
        setBaseWeek("");
      }
      setSelectedBaseDate(date);
      setSelectedSmallBaseDate(null);
      return date;
    }
  };

  // 基準日を空白にした際の初期化処理
  function updataBaseDataInit() {
    const resetBase = (dataList: any[]) => {
      let data: any[] = [];
      for (let i = 0; i < dataList.length; i++) {
        dataList[i]["baseWeekScore"] = "";
        dataList[i]["1wDiffBase"] = "";
        dataList[i]["2wDiffBase"] = "";
        dataList[i]["3wDiffBase"] = "";
        dataList[i]["4wDiffBase"] = "";
        dataList[i]["5wDiffBase"] = "";
        data.push(dataList[i]);
      }
      return data;
    };

    const resetAverage = (dataMap: any) => {
      let averageMap = dataMap;
      averageMap["baseWeekScore"] = "";
      averageMap["1wDiffBase"] = "";
      averageMap["2wDiffBase"] = "";
      averageMap["3wDiffBase"] = "";
      averageMap["4wDiffBase"] = "";
      averageMap["5wDiffBase"] = "";
      return dataMap;
    };
    setTargetData0(resetBase(targetData0));
    setTargetData1(resetBase(targetData1));
    setTargetData2(resetBase(targetData2));
    setTargetData3(resetBase(targetData3));
    setTargetData4(resetBase(targetData4));
    setTargetData5(resetBase(targetData5));
    setTargetData6(resetBase(targetData6));
    setTargetData7(resetBase(targetData7));
    setTargetData8(resetBase(targetData8));
    setTargetDataCommentCount(resetBase(targetDataCommentCount));
    setTargetDataFileCount(resetBase(targetDataFileCount));

    setTargetAverageData0(resetAverage(targetAverageData0));
    setTargetAverageData1(resetAverage(targetAverageData1));
    setTargetAverageData2(resetAverage(targetAverageData2));
    setTargetAverageData3(resetAverage(targetAverageData3));
    setTargetAverageData4(resetAverage(targetAverageData4));
    setTargetAverageData5(resetAverage(targetAverageData5));
    setTargetAverageData6(resetAverage(targetAverageData6));
    setTargetAverageData7(resetAverage(targetAverageData7));
    setTargetAverageData8(resetAverage(targetAverageData8));
    setTargetAverageDataCommentCount(
      resetAverage(targetAverageDataCommentCount)
    );
    setTargetAverageDataFileCount(resetAverage(targetAverageDataFileCount));
  }

  // 小項目表示で基準日を空白にした際の初期化処理
  function updataSmallBaseDataInit() {
    const resetBase = (dataList: any[]) => {
      let data: any[] = [];
      for (let i = 0; i < dataList.length; i++) {
        dataList[i]["baseWeekScore"] = "";
        data.push(dataList[i]);
      }
      return data;
    };
    const resetAverage = (dataMap: any) => {
      let averageMap = dataMap;
      averageMap["baseWeekScore"] = "";
      averageMap["1wDiffBase"] = "";
      averageMap["2wDiffBase"] = "";
      averageMap["3wDiffBase"] = "";
      averageMap["4wDiffBase"] = "";
      averageMap["5wDiffBase"] = "";
      return dataMap;
    };
    setTargetSmallData(resetBase(targetSmallData));
    setTargetSmallAverageData(resetAverage(targetSmallAverageData));
  }

  // 小項目の情報取得
  function getSmallData(
    target_date: DateTime,
    bigItemId: any,
    smallId: any,
    templateItemName?: string,
    uuid?: string
  ) {
    let workAnalysis = String(tabValue + 1);
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }

    const apiParams = {
      "api-name": "analysis",
      target_date: target_date.toFormat("yyyy/MM/dd HH:mm:ss"),
      zo_code: workZoCode,
      ofc_id: ofcId,
      do_code: workDoCode,
      analysis: workAnalysis,
      big_item_id: String(bigItemId),
      small_item_id: String(smallId),
      is_oneweek: false,
      template_item_name: templateItemName,
      template_item_uuid: uuid,
    };
    setExecuteFlg("2");
    // スコアのパーセント表示フラグ
    let percentFlg = false;
    if (workAnalysis !== "4" && workAnalysis !== "5") {
      percentFlg = true;
    } else if (smallId === 100 || smallId === 101) {
      percentFlg = true;
    }

    const url = process.env.REACT_APP_API_URL_J11SPB22 + "tenpocheck/analysis-small";
    return postRequest(url, apiParams)
      .then((res) => {
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];
            let averageScoreBreakdown: any[] =
              datajsList.average_score_breakdown;
            let weekValue: any = datajsList.week_value[0];
            let submissionWeekValue: any = datajsList.submission_week;

            // 添付画像、コメント設定
            const createAttachedIconMap = (resultMap: any): any => {
              const photoFilePath: string = "photoFilePath";
              const commentHandwriteFlag: string = "commentHandwriteFlag";
              const userInputComment: string = "userInputComment";
              const commentFilepathGcs: string = "commentFilepathGcs";
              const photoFlagStr: string = "photo_flag";
              const commentFlagStr: string = "comment_flag";
              const weekNum: number = 5;
              const map: Map<string, string> = new Map<string, string>();
              // resultMapのresult\dは値が大きいものほど過去のため、
              for (let i = 1; i <= weekNum; i++) {
                const result = resultMap[`result${weekNum - i + 1}`];
                map.set(`${photoFilePath}${i}`, result[photoFilePath]);
                map.set(
                  `${commentHandwriteFlag}${i}`,
                  result[commentHandwriteFlag]
                );
                map.set(`${userInputComment}${i}`, result[userInputComment]);
                map.set(
                  `${commentFilepathGcs}${i}`,
                  result[commentFilepathGcs]
                );
                map.set(`${photoFlagStr}${i}`, result[photoFlagStr]);
                map.set(`${commentFlagStr}${i}`, result[commentFlagStr]);
              }
              return Object.fromEntries(map);
            };

            let weekList: any[] = [];
            let headerList = [];
            const dataMapCreate = (
              dataMap: any,
              headerList: any[],
              no: number,
              resultMap: any
            ) => {
              let map: any = {
                name: dataMap.name,
                code: dataMap.code,
                sortDoCode: dataMap.sortDoCode,
                sortOfcCode: dataMap.sortOfcCode,
                ofcName: dataMap.ofcName,
              };
              map["id5"] = resultMap.result1["id"];
              map["id4"] = resultMap.result2["id"];
              map["id3"] = resultMap.result3["id"];
              map["id2"] = resultMap.result4["id"];
              map["id1"] = resultMap.result5["id"];
              map[headerList[4]] = roundOffDecimal(
                resultMap.result1["score" + no]
              );
              map[headerList[3]] = roundOffDecimal(
                resultMap.result2["score" + no]
              );
              map[headerList[2]] = roundOffDecimal(
                resultMap.result3["score" + no]
              );
              map[headerList[1]] = roundOffDecimal(
                resultMap.result4["score" + no]
              );
              map[headerList[0]] = roundOffDecimal(
                resultMap.result5["score" + no]
              );

              map["5wDiff"] = calcDiff(
                resultMap.result1["score" + no],
                resultMap.result2["score" + no]
              );
              map["4wDiff"] = calcDiff(
                resultMap.result2["score" + no],
                resultMap.result3["score" + no]
              );
              map["3wDiff"] = calcDiff(
                resultMap.result3["score" + no],
                resultMap.result4["score" + no]
              );
              map["2wDiff"] = calcDiff(
                resultMap.result4["score" + no],
                resultMap.result5["score" + no]
              );
              map["1wDiff"] = calcDiff(
                resultMap.result5["score" + no],
                resultMap.result6["score" + no]
              );
              return map;
            };

            // 合計値用インターフェイス
            interface totalMap {
              "1w": number;
              "2w": number;
              "3w": number;
              "4w": number;
              "5w": number;
              "6w": number;
            }
            const initTotalMap = () => {
              let map: totalMap = {
                "1w": 0,
                "2w": 0,
                "3w": 0,
                "4w": 0,
                "5w": 0,
                "6w": 0,
              };
              return map;
            };
            // 合計値加算
            const addTotals = (
              map: totalMap,
              num1: any,
              num2: any,
              num3: any,
              num4: any,
              num5: any,
              num6?: any
            ) => {
              map["1w"] += roundOffDecimal(num1);
              map["2w"] += roundOffDecimal(num2);
              map["3w"] += roundOffDecimal(num3);
              map["4w"] += roundOffDecimal(num4);
              map["5w"] += roundOffDecimal(num5);
              // 0week
              map["6w"] += roundOffDecimal(num6);
            };

            // main処理
            let totalCalMap1: any = { score: 0, count: 0 };
            let totalCalMap2: any = { score: 0, count: 0 };
            let totalCalMap3: any = { score: 0, count: 0 };
            let totalCalMap4: any = { score: 0, count: 0 };
            let totalCalMap5: any = { score: 0, count: 0 };
            let totalCalMap6: any = { score: 0, count: 0 };
            const countTotalMap = (score: any, totalmap: any) => {
              if (score >= 0) totalmap.count += 1;
              if (score > 0) totalmap.score += 1;
            };
            // 週名称の設定
            if (weekValue) {
              headerList.push(weekValue.week5 + "週");
              headerList.push(weekValue.week4 + "週");
              headerList.push(weekValue.week3 + "週");
              headerList.push(weekValue.week2 + "週");
              headerList.push(weekValue.week1 + "週");
              setTableHeaderList(headerList);
            }
            // 提出数用週
            if (submissionWeekValue && submissionWeekValue.length > 0) {
              let list: string[] = [];
              list.push(submissionWeekValue[0].week5);
              list.push(submissionWeekValue[0].week4);
              list.push(submissionWeekValue[0].week3);
              list.push(submissionWeekValue[0].week2);
              list.push(submissionWeekValue[0].week1);
              setTableSubmissionHeaderList(list);
            }
            weekList = sortCode(weekList);
            // 項目別の設定
            let scoreList: any[] = [];
            let totalAveragePercentMap: totalMap = initTotalMap();

            let week1PercentCount = 0;
            let week2PercentCount = 0;
            let week3PercentCount = 0;
            let week4PercentCount = 0;
            let week5PercentCount = 0;
            let week6PercentCount = 0;
            let week1Count = 0;
            let week2Count = 0;
            let week3Count = 0;
            let week4Count = 0;
            let week5Count = 0;
            let week6Count = 0;

            for (let j = 0; j < averageScoreBreakdown.length; j++) {
              let name = averageScoreBreakdown[j].name;
              let code = averageScoreBreakdown[j].code;
              let sortDoCode = averageScoreBreakdown[j].sort_docode;
              let sortOfcCode = averageScoreBreakdown[j].sort_ofc_code;
              let ofcName = averageScoreBreakdown[j].ofc_name;
              let result1 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result1
                  ? averageScoreBreakdown[j].result1
                  : "";
              let result2 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result2
                  ? averageScoreBreakdown[j].result2
                  : "";
              let result3 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result3
                  ? averageScoreBreakdown[j].result3
                  : "";
              let result4 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result4
                  ? averageScoreBreakdown[j].result4
                  : "";
              let result5 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result5
                  ? averageScoreBreakdown[j].result5
                  : "";
              let result6 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result6
                  ? averageScoreBreakdown[j].result6
                  : "";
              let submissionWeekValue: any =
                averageScoreBreakdown[j].submissionWeek;
              let map: any = { name, code, sortDoCode, sortOfcCode, ofcName };

              week1PercentCount += countTotalTarget(result1["recordCount1"]);
              week2PercentCount += countTotalTarget(result2["recordCount1"]);
              week3PercentCount += countTotalTarget(result3["recordCount1"]);
              week4PercentCount += countTotalTarget(result4["recordCount1"]);
              week5PercentCount += countTotalTarget(result5["recordCount1"]);
              week6PercentCount += countTotalTarget(result6["recordCount1"]);
              week1Count = result1["recordCount1"];
              week2Count = result2["recordCount1"];
              week3Count = result3["recordCount1"];
              week4Count = result4["recordCount1"];
              week5Count = result5["recordCount1"];
              week6Count = result6["recordCount1"];
              countTotalMap(result1["score1"], totalCalMap1);
              countTotalMap(result2["score1"], totalCalMap2);
              countTotalMap(result3["score1"], totalCalMap3);
              countTotalMap(result4["score1"], totalCalMap4);
              countTotalMap(result5["score1"], totalCalMap5);
              countTotalMap(result6["score1"], totalCalMap6);

              addTotals(
                totalAveragePercentMap,
                result1["score1"],
                result2["score1"],
                result3["score1"],
                result4["score1"],
                result5["score1"],
                result6["score1"]
              );

              let resultMap = {
                result1,
                result2,
                result3,
                result4,
                result5,
                result6,
              };
              scoreList.push(
                tabValue === 2
                  ? Object.assign(
                      dataMapCreate(map, headerList, 1, resultMap),
                      submissionWeekValue
                    )
                  : tabValue === 3
                  ? Object.assign(
                      dataMapCreate(map, headerList, 1, resultMap),
                      createAttachedIconMap(resultMap)
                    )
                  : dataMapCreate(map, headerList, 1, resultMap)
              );
            }

            // 統合の設定
            let averageTitle = "";
            if (tabValue === 0) {
              averageTitle = "ZO";
            } else if (tabValue === 1) {
              averageTitle = "DO";
            } else if (tabValue === 2) {
              averageTitle = "OFC";
            } else if (tabValue === 3) {
              averageTitle = "個別";
            }
            // 地区平均の作成
            let averageMap: any = {
              name: "地区平均／" + averageTitle + "平均",
              code: "average",
            };
            // totalには5～1が逆に入っている
            let average1 = calcPercent(totalCalMap1.score, week1Count);
            let average2 = calcPercent(totalCalMap2.score, week2Count);
            let average3 = calcPercent(totalCalMap3.score, week3Count);
            let average4 = calcPercent(totalCalMap4.score, week4Count);
            let average5 = calcPercent(totalCalMap5.score, week5Count);
            let average6 = calcPercent(totalCalMap6.score, week6Count);

            if (percentFlg) {
              average1 = roundOffDecimal(
                Number(totalAveragePercentMap["1w"]) / week1PercentCount
              );
              average2 = roundOffDecimal(
                Number(totalAveragePercentMap["2w"]) / week2PercentCount
              );
              average3 = roundOffDecimal(
                Number(totalAveragePercentMap["3w"]) / week3PercentCount
              );
              average4 = roundOffDecimal(
                Number(totalAveragePercentMap["4w"]) / week4PercentCount
              );
              average5 = roundOffDecimal(
                Number(totalAveragePercentMap["5w"]) / week5PercentCount
              );
              average6 = roundOffDecimal(
                Number(totalAveragePercentMap["6w"]) / week6PercentCount
              );
              averageMap["1wDiff"] = calcDiff(average5, average6);
              averageMap["2wDiff"] = calcDiff(average4, average5);
              averageMap["3wDiff"] = calcDiff(average3, average4);
              averageMap["4wDiff"] = calcDiff(average2, average3);
              averageMap["5wDiff"] = calcDiff(average1, average2);
            }

            averageMap[headerList[0]] = average5;
            averageMap[headerList[1]] = average4;
            averageMap[headerList[2]] = average3;
            averageMap[headerList[3]] = average2;
            averageMap[headerList[4]] = average1;

            let tmpMap: any = cloneMap(tmpInitTableMap);
            tmpMap["selectedSmallFlg"] = true;
            tmpMap["targetSmallData"] = cloneListMap(sortCode(scoreList));
            tmpMap["targetSmallAverageData"] = cloneMap(averageMap);
            tmpMap["selectedTemplateSmallTitle"] = "0";
            if (templateItemName) {
              tmpMap["selectedTemplateSmallTitle"] = smallId + 1;
            } else {
              tmpMap["selectedSmallTable"] = smallId + 1;
            }

            dispatch(
              updateTenpoCheckManagerMap({
                tenpoCheckManagerMap: tmpMap,
              })
            );
            setTmpInitTableMap(cloneMap(tmpMap));

            setTargetSmallAverageData(averageMap);
            setTargetSmallData(sortCode(scoreList));
            return {
              weekList,
              headerList,
            };
          }
        }
      })
      .finally(() => {
        setExecuteFlg("");
      });
  }

  // 小項目での基準日情報取得
  function getSmallBaseDate(baseDate: DateTime) {
    let workAnalysis = String(tabValue + 1);
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }
    let bigItemId = Number(selectedTable) - 1;
    if (bigItemId === 8 && selectedTemplateBigItemId) {
      bigItemId = Number(selectedTemplateBigItemId);
    }
    let smallId =
      selectedTable === "9" && selectedSmallTitle !== "1"
        ? Number(selectedTemplateSmallTitle) - 1
        : Number(selectedSmallTitle) - 1;

    const apiParams = {
      "api-name": "analysis",
      target_date: baseDate.toFormat("yyyy/MM/dd HH:mm:ss"),
      ofc_id: ofcId,
      zo_code: workZoCode,
      do_code: workDoCode,
      analysis: workAnalysis,
      big_item_id: String(bigItemId),
      small_item_id: String(smallId),
      template_item_name: selectedTable === "9" ? selectedTemplateItemName : "",
      template_item_uuid: selectedTable === "9" ? selectedTemplateItemUuid : "",
      is_oneweek: true,
    };

    setExecuteFlg("2");
    // スコアのパーセント表示フラグ
    let percentFlg = false;
    if (workAnalysis !== "4" && workAnalysis !== "5") {
      percentFlg = true;
    } else if (smallId === 100 || smallId === 101) {
      percentFlg = true;
    }
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "tenpocheck/analysis-small";
    return postRequest(url, apiParams)
      .then((res) => {
        const breakDownDataMap = (
          data: any[],
          code: any,
          score: number,
          id: any
        ) => {
          let dataMap: any = {};
          for (let i = 0; i < data.length; i++) {
            if (code === data[i].code) {
              dataMap = data[i];
            }
          }
          dataMap["baseWeekScore"] = roundOffDecimal(score);
          dataMap["baseId"] = id;
          if (percentFlg) {
            return updateDiff(score, dataMap, tableHeaderList);
          }
          return dataMap;
        };

        const updateDiff = (
          baseScore: number,
          targetMap: any,
          tableHeaderList: any[]
        ) => {
          let dataMap: any = targetMap;

          dataMap["1wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[0]],
            baseScore
          );
          dataMap["2wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[1]],
            baseScore
          );
          dataMap["3wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[2]],
            baseScore
          );
          dataMap["4wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[3]],
            baseScore
          );
          dataMap["5wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[4]],
            baseScore
          );
          return dataMap;
        };

        // main処理
        let totalScore0 = 0;
        let totalCount0 = 0;
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];

            let averageScoreBreakdown: any[] =
              datajsList.average_score_breakdown;
            let weekList: any[] = [];
            weekList = sortCode(weekList);

            let breakDownList: any[] = [];
            let breakDownData = targetSmallData;
            let breakDownAverageData = targetSmallAverageData;
            let totalBaseScore = 0;
            let week1Count = 0;
            for (let j = 0; j < averageScoreBreakdown.length; j++) {
              let code = averageScoreBreakdown[j].code;
              let result1 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result1
                  ? averageScoreBreakdown[j].result1
                  : "";
              let id = result1.id;
              totalCount0 = result1.recordCount1;
              if (result1["score1"] > 0) totalScore0 += 1;
              totalBaseScore += Number(result1.score1);
              week1Count += countTotalTarget(result1.recordCount1);
              const attachedIconMap: {
                photoFilePathBase: string;
                commentHandwriteFlagBase: string;
                userInputCommentBase: string;
                commentFilepathGcsBase: string;
                photo_flag_base: string;
                comment_flag_base: string;
              } = {
                photoFilePathBase: result1.photoFilePath,
                commentHandwriteFlagBase: result1.commentHandwriteFlag,
                userInputCommentBase: result1.userInputComment,
                commentFilepathGcsBase: result1.commentFilepathGcs,
                photo_flag_base: result1.photo_flag,
                comment_flag_base: result1.comment_flag,
              };
              breakDownList.push(
                Object.assign(
                  breakDownDataMap(breakDownData, code, result1.score1, id),
                  attachedIconMap
                )
              );
            }
            // totalには5～1が逆に入っている
            let average0 = calcPercent(totalScore0, totalCount0);

            if (percentFlg) {
              average0 = roundOffDecimal(Number(totalBaseScore) / week1Count);
              updateDiff(average0, breakDownAverageData, tableHeaderList);
            }
            breakDownAverageData["baseWeekScore"] = average0;
            setTargetSmallAverageData(breakDownAverageData);
            setTargetSmallData(sortCode(breakDownList));

            let tmpMap: any = cloneMap(tmpInitTableMap);
            tmpMap["selectedSmallBaseDate"] = baseDate.toFormat("yyyyMMdd");
            tmpMap["targetSmallAverageData"] = cloneMap(breakDownAverageData);
            tmpMap["targetSmallData"] = cloneListMap(sortCode(breakDownList));
            dispatch(
              updateTenpoCheckManagerMap({
                tenpoCheckManagerMap: tmpMap,
              })
            );
            setTmpInitTableMap(cloneMap(tmpMap));
          }
        }
      })
      .catch((r) => {
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      })
      .finally(() => {
        setExecuteFlg("");
      });
  }

  // 基準週による比較値更新
  function updateBaseDate(baseDate: DateTime) {
    userLogging("店舗確認表", "管理者分析#基準日選択", baseDate.toString());
    let workAnalysis = String(tabValue + 1);
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }
    const apiParams = {
      "api-name": "analysis",
      target_date: baseDate.toFormat("yyyy/MM/dd HH:mm:ss"),
      zo_code: workZoCode,
      do_code: workDoCode,
      ofc_id: ofcId,
      tenpo_code: tenpoCode,
      analysis: workAnalysis,
      is_oneweek: true,
    };
    setExecuteFlg("2");
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "tenpocheck/analysis";
    return postRequest(url, apiParams)
      .then((res) => {
        setSelectedTable("1");
        setSelectedSmallTitle("1");
        setSmallTitleList([initSmallTitle, initSmallTitle2, initSmallTitle3]);
        const breakDownDataMap = (data: any[], code: any, score: number) => {
          let dataMap: any = {};
          for (let i = 0; i < data.length; i++) {
            if (code === data[i].code) {
              dataMap = data[i];
            }
          }
          dataMap["baseWeekScore"] = roundOffDecimal(score);
          return updateDiff(score, dataMap, tableHeaderList);
        };

        const updateDiff = (
          baseScore: number,
          targetMap: any,
          tableHeaderList: any[]
        ) => {
          let dataMap: any = targetMap;

          dataMap["1wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[0]],
            baseScore
          );
          dataMap["2wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[1]],
            baseScore
          );
          dataMap["3wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[2]],
            baseScore
          );
          dataMap["4wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[3]],
            baseScore
          );
          dataMap["5wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[4]],
            baseScore
          );
          return dataMap;
        };

        const getUpdateAverage = (
          data: any,
          totalScore: number | string,
          count: number
        ) => {
          let averageMap = data;
          averageMap["baseWeekScore"] = calcAverage(totalScore, count);
          updateDiff(
            calcAverage(totalScore, count),
            averageMap,
            tableHeaderList
          );
          return averageMap;
        };

        // main処理
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];
            let breakdownScoreList: any[] = datajsList.average_score_breakdown;

            let week1Count = 0;
            let breakDownList_0: any[] = [];
            let breakDownList_1: any[] = [];
            let breakDownList_2: any[] = [];
            let breakDownList_3: any[] = [];
            let breakDownList_4: any[] = [];
            let breakDownList_5: any[] = [];
            let breakDownList_6: any[] = [];
            let breakDownList_7: any[] = [];
            let breakDownList_8: any[] = [];
            let breakDownList_commentCount: any[] = [];
            let breakDownList_fileCount: any[] = [];
            let breakDownData_0 = targetData0;
            let breakDownData_1 = targetData1;
            let breakDownData_2 = targetData2;
            let breakDownData_3 = targetData3;
            let breakDownData_4 = targetData4;
            let breakDownData_5 = targetData5;
            let breakDownData_6 = targetData6;
            let breakDownData_7 = targetData7;
            let breakDownData_8 = targetData8;
            let breakDownData_commentCount = targetDataCommentCount;
            let breakDownData_fileCount = targetDataFileCount;
            let totalScore0 = 0;
            let totalScore1 = 0;
            let totalScore2 = 0;
            let totalScore3 = 0;
            let totalScore4 = 0;
            let totalScore5 = 0;
            let totalScore6 = 0;
            let totalScore7 = 0;
            let totalScore8 = 0;
            let totalScoreCommentCount = 0;
            let totalScoreFileCount = 0;

            for (let j = 0; j < breakdownScoreList.length; j++) {
              let code = breakdownScoreList[j].codeName.code;
              let result1 =
                breakdownScoreList[j] && breakdownScoreList[j].result1
                  ? breakdownScoreList[j].result1
                  : "";

              week1Count += countTotalTarget(result1.recordCount1);
              totalScore0 += Number(result1.score0);
              totalScore1 += Number(result1.score1);
              totalScore2 += Number(result1.score2);
              totalScore3 += Number(result1.score3);
              totalScore4 += Number(result1.score4);
              totalScore5 += Number(result1.score5);
              totalScore6 += Number(result1.score6);
              totalScore7 += Number(result1.score7);
              totalScore8 += Number(result1.score8);
              totalScoreCommentCount += Number(result1.comment_count);
              totalScoreFileCount += Number(result1.file_count);
              breakDownList_0.push(
                breakDownDataMap(breakDownData_0, code, result1.score0)
              );
              breakDownList_1.push(
                breakDownDataMap(breakDownData_1, code, result1.score1)
              );
              breakDownList_2.push(
                breakDownDataMap(breakDownData_2, code, result1.score2)
              );
              breakDownList_3.push(
                breakDownDataMap(breakDownData_3, code, result1.score3)
              );
              breakDownList_4.push(
                breakDownDataMap(breakDownData_4, code, result1.score4)
              );
              breakDownList_5.push(
                breakDownDataMap(breakDownData_5, code, result1.score5)
              );
              breakDownList_6.push(
                breakDownDataMap(breakDownData_6, code, result1.score6)
              );
              breakDownList_7.push(
                breakDownDataMap(breakDownData_7, code, result1.score7)
              );
              breakDownList_8.push(
                breakDownDataMap(breakDownData_8, code, result1.score8)
              );
              breakDownList_commentCount.push(
                breakDownDataMap(
                  breakDownData_commentCount,
                  code,
                  result1.comment_count
                )
              );
              breakDownList_fileCount.push(
                breakDownDataMap(
                  breakDownData_fileCount,
                  code,
                  result1.file_count
                )
              );
            }

            let averageMap = getUpdateAverage(
              targetAverageData0,
              totalScore0,
              week1Count
            );
            setTargetAverageData(averageMap);
            setTargetAverageData0(averageMap);
            setTargetAverageData1(
              getUpdateAverage(targetAverageData1, totalScore1, week1Count)
            );
            setTargetAverageData2(
              getUpdateAverage(targetAverageData2, totalScore2, week1Count)
            );
            setTargetAverageData3(
              getUpdateAverage(targetAverageData3, totalScore3, week1Count)
            );
            setTargetAverageData4(
              getUpdateAverage(targetAverageData4, totalScore4, week1Count)
            );
            setTargetAverageData5(
              getUpdateAverage(targetAverageData5, totalScore5, week1Count)
            );
            setTargetAverageData6(
              getUpdateAverage(targetAverageData6, totalScore6, week1Count)
            );
            setTargetAverageData7(
              getUpdateAverage(targetAverageData7, totalScore7, week1Count)
            );
            setTargetAverageData8(
              getUpdateAverage(targetAverageData8, totalScore8, week1Count)
            );
            setTargetAverageDataCommentCount(
              getUpdateAverage(
                targetAverageDataCommentCount,
                totalScoreCommentCount,
                week1Count
              )
            );
            setTargetAverageDataFileCount(
              getUpdateAverage(
                targetAverageDataFileCount,
                totalScoreFileCount,
                week1Count
              )
            );

            setTargetData(sortCode(breakDownList_0));
            setTargetData0(sortCode(breakDownList_0));
            setTargetData1(sortCode(breakDownList_1));
            setTargetData2(sortCode(breakDownList_2));
            setTargetData3(sortCode(breakDownList_3));
            setTargetData4(sortCode(breakDownList_4));
            setTargetData5(sortCode(breakDownList_5));
            setTargetData6(sortCode(breakDownList_6));
            setTargetData7(sortCode(breakDownList_7));
            setTargetData8(sortCode(breakDownList_8));
            setTargetDataCommentCount(sortCode(breakDownList_commentCount));
            setTargetDataFileCount(sortCode(breakDownList_fileCount));

            let tmpMap: any = cloneMap(tmpInitTableMap);
            tmpMap["targetAverageData0"] = cloneMap(
              getUpdateAverage(targetAverageData0, totalScore0, week1Count)
            );
            tmpMap["targetAverageData1"] = cloneMap(
              getUpdateAverage(targetAverageData1, totalScore1, week1Count)
            );
            tmpMap["targetAverageData2"] = cloneMap(
              getUpdateAverage(targetAverageData2, totalScore2, week1Count)
            );
            tmpMap["targetAverageData3"] = cloneMap(
              getUpdateAverage(targetAverageData3, totalScore3, week1Count)
            );
            tmpMap["targetAverageData4"] = cloneMap(
              getUpdateAverage(targetAverageData4, totalScore4, week1Count)
            );
            tmpMap["targetAverageData5"] = cloneMap(
              getUpdateAverage(targetAverageData5, totalScore5, week1Count)
            );
            tmpMap["targetAverageData6"] = cloneMap(
              getUpdateAverage(targetAverageData6, totalScore6, week1Count)
            );
            tmpMap["targetAverageData7"] = cloneMap(
              getUpdateAverage(targetAverageData7, totalScore7, week1Count)
            );
            tmpMap["targetAverageData8"] = cloneMap(
              getUpdateAverage(targetAverageData8, totalScore8, week1Count)
            );
            tmpMap["targetAverageDataCommentCount"] = cloneMap(
              getUpdateAverage(
                targetAverageDataCommentCount,
                totalScoreCommentCount,
                week1Count
              )
            );
            tmpMap["targetAverageDataFileCount"] = cloneMap(
              getUpdateAverage(
                targetAverageDataFileCount,
                totalScoreFileCount,
                week1Count
              )
            );
            tmpMap["targetList0"] = cloneListMap(sortCode(breakDownList_0));
            tmpMap["targetList1"] = cloneListMap(sortCode(breakDownList_1));
            tmpMap["targetList2"] = cloneListMap(sortCode(breakDownList_2));
            tmpMap["targetList3"] = cloneListMap(sortCode(breakDownList_3));
            tmpMap["targetList4"] = cloneListMap(sortCode(breakDownList_4));
            tmpMap["targetList5"] = cloneListMap(sortCode(breakDownList_5));
            tmpMap["targetList6"] = cloneListMap(sortCode(breakDownList_6));
            tmpMap["targetList7"] = cloneListMap(sortCode(breakDownList_7));
            tmpMap["targetList8"] = cloneListMap(sortCode(breakDownList_8));
            tmpMap["targetListCommentCount"] = cloneListMap(
              sortCode(breakDownList_commentCount)
            );
            tmpMap["targetListFileCount"] = cloneListMap(
              sortCode(breakDownList_fileCount)
            );
            tmpMap["selectedBaseDate"] = baseDate.toFormat("yyyyMMdd");
            tmpMap["selectedTable"] = "1";
            tmpMap["selectedSmallTable"] = "1";
            tmpMap["smallTitleList"] = [
              initSmallTitle,
              initSmallTitle2,
              initSmallTitle3,
            ];
            tmpMap["selectedTemplateSmallTitle"] = "0";

            dispatch(
              updateTenpoCheckManagerMap({
                tenpoCheckManagerMap: tmpMap,
              })
            );
            setTmpInitTableMap(cloneMap(tmpMap));
          }
        }
      })
      .catch((r) => {
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      })
      .finally(() => {
        setExecuteFlg("");
      });
  }

  // タブ内表示
  function tableResult(num: number) {
    return (
      <>
        <Grid style={{ width: "85vw" }}>
          <Grid
            container
            style={{
              padding: "10px",
            }}
          >
            <Grid item style={{ paddingRight: "15px" }}>
              <Select
                style={{
                  minWidth: 320,
                  maxWidth: 320,
                }}
                onChange={(event) => doSelChange(event)}
                value={selectedTable}
                disabled={tabValue === 5}
              >
                {tableList.map((rowItem) => (
                  <MenuItem value={rowItem.id}>{rowItem.name}</MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item style={{ paddingRight: "15px" }}>
              <Select
                style={{
                  minWidth: tabValue !== 2 ? 320 : 300,
                  maxWidth: tabValue !== 2 ? 320 : 300,
                }}
                onChange={(event) => doSmallSelChange(event)}
                value={selectedSmallTitle}
              >
                {smallTitleList.map((rowItem) => (
                  <MenuItem value={rowItem.id}>{rowItem.name}</MenuItem>
                ))}
              </Select>
            </Grid>

            {selectedTable === "9" && selectedSmallTitle !== "1" && tabValue !== 5 ? (
              <Grid item style={{ paddingRight: "15px" }}>
                <Select
                  style={{
                    minWidth: 320,
                    maxWidth: 320,
                  }}
                  onChange={(event) => doTemplateSmallSelChange(event)}
                  value={selectedTemplateSmallTitle}
                >
                  {templateSmallItemList.map((rowItem) => (
                    <MenuItem value={rowItem.id}>{rowItem.name}</MenuItem>
                  ))}
                </Select>
              </Grid>
            ) : (
              ""
            )}

            {/* テンプレートタブの場合は週選択、それ以外は基準日選択 */}
            {tabValue === 5 ? (
              <Grid item style={{ paddingRight: "15px" }}>
                <Select
                  style={{
                    minWidth: 200,
                    maxWidth: 200,
                  }}
                  value={selectedWeek}
                  onChange={(event) => setSelectedWeek(String(event.target.value))}
                >
                  {weekOptions.map((week) => (
                    <MenuItem key={week.value} value={week.value}>
                      {week.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            ) : (
              <Grid item>
                <Grid container>
                  <Typography>基準日：</Typography>
                  <DatePicker
                    selectedDate={
                      !selectedSmallFlg ? selectedBaseDate : selectedSmallBaseDate
                    }
                    width={180}
                    dateFunc={(date: DateTime | null) => {
                      handleBaseDate(date);
                    }}
                    format={"yyyy年MM月dd日"}
                    minDate={DateTime.fromFormat("20000101", "yyyyMMdd")}
                    mainColor={"#4dc0b2"}
                  />
                </Grid>
              </Grid>
            )}
            {tabValue === 2 ? (
              <>
                <Grid item style={{ paddingRight: "10px" }}>
                  <Button
                    variant="contained"
                    color={"primary"}
                    onClick={() => moveClickDMAll()}
                  >
                    DO内個店別分析
                  </Button>
                </Grid>
                <Grid item style={{ paddingRight: "10px" }}>
                  <Button
                    variant="contained"
                    color={"primary"}
                    onClick={() => moveClickDMAllTemplate()}
                  >
                    DO内個店別分析(テンプレート)
                  </Button>
                </Grid>
              </>
            ) : (
              ""
            )}
            {(tabValue === 0 ||
              (tabValue === 1 && workZoCode) ||
              (tabValue === 2 && workDoCode)) &&
            (isDownloadPointData(user) ||
              (tabValue === 2 && isDmCheck(user))) ? (
              <Grid
                container
                justify="flex-end"
                alignItems="center"
                style={{ margin: "3px" }}
              >
                <TenpoCheckStoreScoreDataButton
                  csvZoCode={tabValue === 1 ? workZoCode : ""}
                  csvDoCode={tabValue === 2 ? workDoCode : ""}
                  addWeek={0}
                />
                <TenpoCheckStoreScoreDataButton
                  csvZoCode={tabValue === 1 ? workZoCode : ""}
                  csvDoCode={tabValue === 2 ? workDoCode : ""}
                  addWeek={-7}
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          
          {(() => {
            // テンプレートタブの場合（tabValue === 5）は、データがなくても表示
            if (tabValue === 5) {
              // 選択されたテンプレートの小項目を取得
              let selectedTemplateItems = [];
              if (selectedSmallTitle !== "1" && templatesMap[selectedSmallTitle]) {
                selectedTemplateItems = templatesMap[selectedSmallTitle].smallItems || [];
              }
              
              // デバッグ用ログ
              console.log("===== TenpoCheckManagerAnalysisResult Debug =====");
              console.log("selectedSmallTitle:", selectedSmallTitle);
              console.log("templatesMap:", templatesMap);
              console.log("templatesMap[selectedSmallTitle]:", templatesMap[selectedSmallTitle]);
              console.log("selectedTemplateItems:", selectedTemplateItems);
              console.log("selectedTemplateItems structure:", selectedTemplateItems.map((item: any) => ({
                id: item.id,
                name: item.name,
                uuid: item.uuid,
                template_item_uuid: item.template_item_uuid
              })));
              
              // 全体が選択されている場合は全テンプレート項目を使用
              const displayTemplateItems = selectedSmallTitle === "1" 
                ? templateItemList.filter(item => item.id !== 1) // "全体"を除く全テンプレート項目
                : selectedTemplateItems;
              
              return (
                <TenpoCheckManagerAnalysisTemplateTable
                  data={targetData || []}
                  templateItems={displayTemplateItems}
                  selectedSmallTitle={selectedSmallTitle}
                  zoCode={workZoCode}
                  doCode={workDoCode}
                  selectedTemplateId={selectedSmallTitle !== "1" ? selectedSmallTitle : undefined}
                  selectedWeek={selectedWeek}
                />
              );
            } else if (targetData && targetData.length > 0) {
              return (
                <>
                  <TenpoCheckManagerAnalysisTable
                    data={targetData}
                    averageData={targetAverageData}
                    headerName={headerName}
                    tableHeaderList={tableHeaderList}
                    tableSubmissionHeaderList={tableSubmissionHeaderList}
                    tabValue={tabValue}
                    graphUserList={graphUserList}
                    baseWeek={!selectedSmallFlg ? baseWeek : smallBaseWeek}
                    onClickMove={(code) => moveClick(code)}
                    onClickSelect={(code, name) => selectClick(code, name)}
                    smallFlg={selectedSmallFlg}
                    smallData={targetSmallData}
                    smallAverageData={targetSmallAverageData}
                    bigItemId={String(Number(selectedTable) - 1)}
                    smallItemId={String(
                      selectedTable === "9" && selectedSmallTitle !== "1"
                        ? Number(selectedTemplateSmallTitle)
                        : Number(selectedSmallTitle) - 1
                    )}
                    selectedTable={selectedTable}
                    selectedTemplateItemName={selectedTemplateItemName} 
                    selectedTemplateItemUuid={selectedTemplateItemUuid}
                  />
                  {!selectedSmallFlg && tabValue !== 5 ? (
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      className={classes.graphTable}
                    >
                      <ResponsiveContainer width={"100%"} height={400}>
                        <LineChart
                          data={targetGraphData}
                          margin={{ top: 5, right: 40, bottom: 60, left: 0 }}
                          stackOffset="none"
                          height={400}
                        >
                          <XAxis dataKey="week" interval={0} />
                          <YAxis domain={[0, 100]} />
                          <Tooltip />
                          <Legend verticalAlign="top" />
                          <ReferenceLine y={0} stroke="#000" />
                          {graphUserList.map((item: any) => (
                            <Line dataKey={item.name} stroke={item.fill} />
                          ))}
                        </LineChart>
                      </ResponsiveContainer>
                    </Grid>
                  ) : (
                    ""
                  )}
                </>
              );
            } else {
              return "";
            }
          })()}
        </Grid>
      </>
    );
  }

  return (
    <Grid>
      {executeFlg === "2" ? ( // 検索中のぐるぐる表示
        <>
          <CircularProgress className={classes.circularProgress} size={120} />
          <Grid className={classes.overLayer}></Grid>
        </>
      ) : (
        ""
      )}
      <AppBar
        position="static"
        style={{
          padding: "0",
          margin: "auto",
          width: "90vw",
          outlineColor: "#3e3e3e",
          backgroundColor: "#f2f2f2",
          color: "#3e3e3e",
        }}
      >
        <Tabs
          variant="standard"
          value={indexTabValue}
          onChange={handleChange}
          aria-label="nav tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#37ab9d",
              height: "10px",
            },
          }}
        >
          {hasManagerAnalysisFullReferencePrivileges(user) ? (
            <Tab
              label="ZO別分析"
              disabled={executeFlg === "1" || zoTabDisableFlg}
            />
          ) : (
            ""
          )}
          {hasManagerAnalysisFullReferencePrivileges(user) || isZmCheck(user) ? (
            <Tab
              label="DO別分析"
              disabled={executeFlg === "1" || doTabDisableFlg}
            />
          ) : (
            ""
          )}
          <Tab
            label="OFC別分析"
            disabled={executeFlg === "1" || ofcTabDisableFlg}
          />
          <Tab
            label="個店別分析"
            disabled={executeFlg === "1" || kobetuTabDisableFlg}
          />
          <Tab
            label="個店別分析(テンプレート)"
            disabled={executeFlg === "1" || templateTabDisableFlg}
          />
        </Tabs>
      </AppBar>
      {executeFlg === "1" ? ( // 検索中のぐるぐる表示
        <>
          <Grid
            style={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            <CircularProgress
              size={"40vh"}
              style={{
                color: "#ccc",
                top: "30vh",
                position: "absolute",
              }}
            />
          </Grid>
        </>
      ) : (
        <>
          {hasManagerAnalysisFullReferencePrivileges(user) ? (
            <TabPanel value={indexTabValue} index={0}>
              <Grid className={classes.root}>{tableResult(0)}</Grid>
            </TabPanel>
          ) : (
            ""
          )}
          {hasManagerAnalysisFullReferencePrivileges(user) || isZmCheck(user) ? (
            <TabPanel value={tabValue} index={1}>
              <Grid className={classes.root}>{tableResult(1)}</Grid>
            </TabPanel>
          ) : (
            ""
          )}
          <TabPanel value={tabValue} index={2}>
            <Grid className={classes.root}>{tableResult(2)}</Grid>
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <Grid className={classes.root}>{tableResult(3)}</Grid>
          </TabPanel>
          <TabPanel value={tabValue} index={5}>
            <Grid className={classes.root}>{tableResult(5)}</Grid>
          </TabPanel>
        </>
      )}
      {/* ダイアログ */}
      <TenpoCheckDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogClose}
        doNo={dialogClose}
        isAlert={true}
      />
    </Grid>
  );
};
export default AnalysisResult;
